import { IconButton, List, MenuItem, Select, Tab, Tabs, TextField, InputLabel, ListItemIcon } from '@material-ui/core'
import { DialogActions, DialogTitle, ListItem, ListItemText, Grid, Box, Drawer, ListItemButton, Modal, CircularProgress, Typography, Button, Popover, Tooltip, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Collapse, Radio, FormControl, FormLabel, FormControlLabel, RadioGroup, Dialog, DialogContentText, FormHelperText, OutlinedInput } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Pagination from '@mui/material/Pagination';
import { FileDownloadOff, Download, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import editUser from '../../../../../ui-assets/eidtUser.png'
import { useEffect, useState } from 'react'
import { httpRequest } from '../../../../../ui-utils/api'
import { backendHosts, apiUrl } from '../../../../../ui-utils/apiConfig'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { DataGrid } from '@mui/x-data-grid'
import CheckIcon from '@mui/icons-material/Check'; // Green tick
import KeyIcon from '@mui/icons-material/Key';
import * as CryptoJS from 'crypto-js';
import success from '../../../../../ui-assets/upload_success.gif'
import errorgif from '../../../../../ui-assets/upload_error.gif'
import loadergif from '../../../../../ui-assets/upload_loader.gif'
import verified from '../../../../../ui-assets/verified.svg'
import UploadDocument from './UploadDocument'
// added by dev-kartik on 02-04-25
import axios from "axios";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { FileUploader } from "react-drag-drop-files";
import Swal from "sweetalert2";
import { PDFDocument } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist";
import Fno_Activation from './Fno_Activation';
pdfjsLib.GlobalWorkerOptions.workerSrc =
    `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.js`;


//Worked on the modal by dev-trupti on 21-08-2024
const EditActionModal = ({
    accountno,
    editModal,

 
    selectUser,
    handleAccountno,
    handleFatherName,
    handleEditModal,
    aadhar,
    phone,
    email,
    accountnumber,
    regData,
    load,
    setLoad,
    bankAccount,
    setBankAccount,
    image,
    setImage,
    CompletedVerification,
    disRepush,
    setDisRepush,
    setSnack,
    setMsg,
    subData, //dev-trupti on 31-10-2024
    nri,
    docstatus,
    setDocstatus,
    docobj,
    prefix,




    kycDetails,
    perData,
    picDetails,
    setNum,
    id,
    setPicDetails,
    docVerification,
    setDocVerification,
    setRegData,
    setPerData,
    details,
    fatherName
}) => {

    console.log("picDetails1", picDetails)
    console.log("perData", perData,fatherName)
    console.log("Details", details)
    const [tabvalue, setTabvalue] = useState("1")
    const [isAccForm, setIsaccform] = useState(false)
    const [isAadhar, setIsaadhar] = useState(false)
    const [isPan, setIspan] = useState(false)
    const [isCancheque, setIscancheque] = useState(false)
    const [isSelfie, setIsselfie] = useState(false)
    const [isSign, setIssign] = useState(false)
    const [isAA, setIsaa] = useState(false)
    const [isPoa, setIsPoa] = useState(false)
    const [isNri, setIsNri] = useState({
        isPis : false,
        isPan:false,
        isIdentity : false,
        isBankStatement : false,
        isCommunication : false
    })
    const [year, setYear] = useState("")
    const [verification, setVerification] = useState("")
    const [createdOn, setCreatedOn] = useState("")
    const [data, setData] = useState(JSON.stringify(regData?.[0]?.data))
    const [acc,setAcc] = useState("")
    const [ifsc,setIfsc] = useState("")
    const [bankHolderName, setBankHolderName] = useState("")
    const [isName,setIsName] = useState(true)
    //Showing Image on hover start by dev-trupti on 27-09-2024
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [selectedIndex1, setSelectedIndex1] = useState(0)
    const [selectedIndex2,setSelectedIndex2]=useState(0)
    const [anchorEl, setAnchorEl] = useState(null);
    const [download, setDownload] = useState(false)
    const [preview , setPreview] = useState(false)
    const [previewimg, setPreviewImg] = useState("")
    const [previewtext, setPreviewText] = useState("")
    const [loader, setLoader] = useState(false)
    const [hover, setHover] = useState("")
    // added copy + subscription table dev-trupti on 31-10-2024
    const [copyText, setCopyText] = useState("Copy")
    const [copyText1, setCopyText1] = useState("This PDF is encrypted click to copy the password!")
    const [rows, setRows] = useState([])
    const [opencol, setOpenCol] = useState(false)
    const [paymentHistory, setPaymentHistory] = useState([])
    const [bankType, setBankType] = useState("Savings") //dev-trupti on 17-12-2024
    const [docdata, setDocdata] = useState({})
    const [viewdata, setViewdata] = useState(0);
    const [docloader, setDocloader] = useState(false)
    const [loaderstatus, setLoaderstatus] = useState({
        type:'confirm',
        title:'',
        content:'',
        doctype:''
    })
    const [verify, setVerify] = useState(false)
    const [bankapproved, setBankapproved] = useState({
        accno:'',
        ifsc:'',
        name:''
    })
    const [uploadmodal, setUploadmodal] = useState({
        open:false,
        type:'',
    })

    const [uploadModalState, setUploadModalState] = useState({ open: false, type: "" });
    const resendArr = ["Repush", "Selfie", "Signature"]
    const [repushLoader,setRepushLoader]=useState(false)

    const username = localStorage.getItem('username')
    const userId = JSON.parse(localStorage.getItem('sipRegData'))?.sip_id 
    console.log("username", username, userId)
    let fno
    if (perData){
        console.log("edittt",perData)
     fno={
        mobile:perData?.mobile,
        email:perData?.email,
        client_id: perData?.client_id
    }
}
    // added by dev-kartik on 02-04-25
    const [aggregatorModal, setAggregatorModal] = useState(false);
    const [baseData, setBaseData] = useState("");
    const [promise, setpromise] = useState(null);
    const [enable, setEnable] = useState(false);
    const [error, setError] = useState("");
    const [documentType, setDocumentType] = useState("Bank_Statement");
    const [show, setShow] = useState(false);
    const [password, setPassword] = useState("");
    // const [docType,setDocType]=useState("")
    // const [path, setPath] = useState("")
    const [bankDetails, setBankDetails] = useState(null)
    const [detailsIndex,setDetailsIndex]=useState(0)
    const [onBoardIndex, setOnBoardIndex] = useState(0)
    const [detailsData,setDetailsData]=useState(null)
    const [onBoardData, setOnBoardData] = useState("UserDetails")
    const [kycOnBoardData,setKycOnBoardData]=useState(null)
    const [aadhaarData, setAadhaarData] = useState({
        aadhaar_number: '',
        dob: '',
        fullName: '',
        state: '',
        district: '',
        pincode: '',
        address1: '',
        address2: '',
        city:""
    })
    const [aadhaarErrors, setAadhaarErrors] = useState({});
    const [disableOcr, setDisableOcr] = useState(false)
    const [aadhaarAddress,setAadhaarAddress]=useState("")
    let onboardDetials = ["UserDetails", "PersonalDetatils", "BankDetails", "ResidentialAddress","RegisteredAddress","ContactDetails","Documents","IncomeDetails","NomineeDetails","Segments","OtherDetails"]
    const [resendUrl,setResendUrl]=useState("")
    const [openResendModal, setOpenResendModal] = useState(false);
    const [resendError, setResendError] = useState("");
    const [resendSignError, setresendSignError] = useState("");
    const [contentText,setContentText]=useState("")
    const [user, setUser] = useState([])

    
    // const alphabets = perData?.client_id?.replace(/[^a-zA-Z]/g, "");
    // const digits = perData?.client_id?.replace(/[^0-9]/g, "");

    // console.log("Alphabets:", alphabets);
    // console.log("Digits:", digits);
    // setPrefix(alphabets)
    // setSuffix(digits)

    const stateOptions = [
        { CODE: "UTTAR PRADESH", Description: "Uttar Pradesh" },
        { CODE: "Arunachal Pradesh", Description: "Arunachal Pradesh" },
        { CODE: "Assam", Description: "Assam" },
        { CODE: "Andhra Pradesh", Description: "Andhra Pradesh" },
        { CODE: "Andaman & Nicobar", Description: "Andaman & Nicobar" },
        { CODE: "Bihar", Description: "Bihar" },
        { CODE: "Chandigarh", Description: "Chandigarh" },
        { CODE: "Chhatisgarh", Description: "Chhatisgarh" },
        { CODE: "Delhi", Description: "Delhi" },
        { CODE: "Daman & Diu", Description: "Daman & Diu" },
        { CODE: "Nagar Haveli", Description: "Nagar Haveli" },
        { CODE: "Gujarat", Description: "Gujarat" },
        { CODE: "Goa", Description: "Goa" },
        { CODE: "Himachal Pradesh", Description: "Himachal Pradesh" },
        { CODE: "Haryana", Description: "Haryana" },
        { CODE: "Jammu & Kashmir", Description: "Jammu & Kashmir" },
        { CODE: "Jharkhand", Description: "Jharkhand" },
        { CODE: "Karnataka", Description: "Karnataka" },
        { CODE: "Kerala", Description: "Kerala" },
        { CODE: "Lakshadweep", Description: "Lakshadweep" },
        { CODE: "Manipur", Description: "Manipur" },
        { CODE: "Mizoram", Description: "Mizoram" },
        { CODE: "Meghalaya", Description: "Meghalaya" },
        { CODE: "Madhya Pradesh", Description: "Madhya Pradesh" },
        { CODE: "Maharashtra", Description: "Maharashtra" },
        { CODE: "Nagaland", Description: "Nagaland" },
        { CODE: "Orissa", Description: "Orissa" },
        { CODE: "Punjab", Description: "Punjab" },
        { CODE: "Pondicherry", Description: "Pondicherry" },
        { CODE: "Rajasthan", Description: "Rajasthan" },
        { CODE: "Sikkim", Description: "Sikkim" },
        { CODE: "Tripura", Description: "Tripura" },
        { CODE: "Tamil Nadu", Description: "Tamil Nadu" },
        { CODE: "Uttarakhand", Description: "Uttarakhand" },
        { CODE: "West Bengal", Description: "West Bengal" },
        { CODE: "Dadra and Nagar Haveli", Description: "Dadra and Nagar Haveli" },
        { CODE: "TELANGANA", Description: "Telengana" },
        { CODE: "OTHER", Description: "Other" },
    ];

    const handleResendSelfieLink=async()=>{
        try{

            const payload = {
                 data:{
                    email:perData?.email,
                    mobile:perData?.mobile,
                    id,
                    crm_agent: username,
                    name:perData?.name|| "Client"
                 }
            }

            console.log("selfiepayloadd",payload)

            const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.selfieResendLink}`,payload)
            
            let data=response?.data?.data?.data

            console.log("resend selfie response", data, response?.data?.data)

            if (response?.data?.data?.status && data?.success){
                console.log("successs",data?.link)
                setResendUrl(data?.link)
                setOpenResendModal(true)
                setContentText("Hi there!\n\nYour KYC needs a quick selfie retake. Please use the link below to finish the verification:")
                setResendError("")
            }else{
                setResendUrl("")
                setContentText("")
                setResendError(data?.message || "Something went wrong.Please try again later")
                console.log("something went wrong")
            }

        }catch(error){
            setResendUrl("")
            setContentText("")
            setResendError(error?.response?.data?.data?.data?.message || "Something went wrong.Please try again later")
            console.log("Something went wrong", error)
        }
    }

    const handleResendSignLink = async () => {
        try {

            const payload = {
                data: {
                    email: perData?.email,
                    mobile: perData?.mobile,
                    id,
                    crm_agent: username,
                    name: perData?.name || "Client"
                }
            }

            console.log("Signpayloadd", payload)

            const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.signResendLink}`, payload)

            let data = response?.data?.data?.data

            console.log("resend Sign response", data, response?.data?.data)

            if (response?.data?.data?.status && data?.success) {
                console.log("successs", data?.link)
                setResendUrl(data?.link)
                setOpenResendModal(true)
                setContentText("Hi there!\n\nYour KYC needs a quick signature retake. Please use the link below to finish the verification:")
                setresendSignError("")
            } else {
                setResendUrl("")
                setContentText("")
                setresendSignError(data?.message || "Something went wrong.Please try again later")
                console.log("something went wrong")
            }

        } catch (error) {
            setContentText("")
            setResendUrl("")
            setresendSignError(error?.response?.data?.data?.data?.message || "Something went wrong.Please try again later")
            console.log("Something went wrong", error)
        }
    }
    

    const handleResendCopy = () => {
        const combined = `${contentText}\n\n${resendUrl}`;
        navigator.clipboard.writeText(combined);
    };


    


    useEffect(()=>{
        if (tabvalue === "6") {
            fetchOnBoardData();
        }
    }, [tabvalue])

    const fetchOnBoardData = async () => {
        console.log("hello",id)
        const payload = {
            data: {
                id: `${id}`
            }
        }
        try {
            const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.kycOnBoardUser}`,payload);
            if(response?.status == 200){
                const result = response.data?.data?.data?.data
                console.log("onBoardData",result )
                setKycOnBoardData(result)
            }
        
        } catch (error) {
            console.error("fetchOnBoardData API Error:", error);
        }
    };


    useEffect(() => {
        if (Array.isArray(docVerification) && docVerification.length > 0) {
            setViewdata(docVerification[0]); // Set the first item when docVerification is available
        }
        setDetailsData(details?.[0])
        setData(JSON.stringify(regData?.[0]?.data))
        setCreatedOn(regData?.[0]?.createdAt)

    }, [docVerification, details, regData]);

    const handleRepush=async()=>{
        try{
           setRepushLoader(true)
            const payload={
                data:{
                    id,
                    onboardingSource: "crm", 
                    crmUserName: username,
                    crmUserId: userId
                }
            }
            const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.repush}`,payload)
            let data = response?.data?.data?.data
            console.log("Repush responsee",data)
           
            if (response?.data?.data?.status && data?.success){
                setRepushLoader(false)
                Swal.fire({
                    html: `
                    <p style="
                        font-size: 24px;
                        font-family: 'cardiuma-M', sans-serif;
                        white-space: normal;
                        word-break: break-word;
                    ">
                        ${data?.message}
                    </p>
                `,
                    willOpen: () => {
                        const swalContainer = document.querySelector(".swal2-container");
                        if (swalContainer) {
                            swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                        }
                    },
                });
            }else{
                setRepushLoader(false)
                Swal.fire({
                    html: `
                    <p style="
                        font-size: 24px;
                        font-family: 'cardiuma-regular', sans-serif;
                        white-space: normal;
                        word-break: break-word;
                    ">
                        ${ data?.message || "Something went wrong.Please try again later"}
                    </p>
                `,
                    willOpen: () => {
                        const swalContainer = document.querySelector(".swal2-container");
                        if (swalContainer) {
                            swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                        }
                    },
                });
            }

        }catch(error){
            setRepushLoader(false)
            console.error("repush API Error:", error?.response?.data?.error);
            Swal.fire({
                html: `
                    <p style="
                        font-size: 24px;
                        font-family: 'cardiuma-regular', sans-serif;
                        white-space: normal;
                        word-break: break-word;
                    ">
                        ${error?.response?.data?.error || "Something went wrong.Please try again later"}
                    </p>
                `,
                willOpen: () => {
                    const swalContainer = document.querySelector(".swal2-container");
                    if (swalContainer) {
                        swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                    }
                },
            }); 
        }
    }

    const handleKycCheck =async()=>{

        try{
            const payload = {
                data: {
                    client_id: perData.client_id
                }
            }
            const response = await axios.post(`${backendHosts.BACK_OFFICE}${apiUrl.kycCheck}`, payload)
            console.log("KYC Check Response", response?.data?.data?.["Success Description"])
            
            if (response?.data?.status == 200 && response?.data?.data?.Success == "True" && response?.data?.data?.["Success Description"]) {
                console.log("successs", response?.data?.data?.["Success Description"])
                Swal.fire({
                    html: `
                    <p style="
                        font-size: 24px;
                        font-family: 'cardiuma-M', sans-serif;
                        white-space: normal;
                        word-break: break-word;
                    ">
                        ClientId - ${response?.data?.data?.["Success Description"][0].CLIENT_ID} <br/>
                        Client Name - ${response?.data?.data?.["Success Description"][0].CLIENT_NAME} <br/>
                        <p style="font-family: 'cardiuma-Bold', sans-serif; padding-top: 5px; font-size: 24px;">Client has already been added</p>
                     </p>
                `,
                    icon: "info",
                    willOpen: () => {
                        const swalContainer = document.querySelector(".swal2-container");
                        if (swalContainer) {
                            swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                        }
                    },
                });
            } else {
                Swal.fire({
                    html: `
                    <p style="
                        font-size: 24px;
                        font-family: 'cardiuma-Bold', sans-serif;
                        white-space: normal;
                        word-break: break-word;
                        text-transform:capitalize
                    ">
                        ${response?.data?.data?.["Error Description"]}
                    </p>
                `, 
                    icon: "info",
                    willOpen: () => {
                        const swalContainer = document.querySelector(".swal2-container");
                        if (swalContainer) {
                            swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                        }
                    },
                });
                console.log("Failed", response?.data?.data?.["Error Description"])
            }
        }catch(err){
             console.log("Somthing went Wrong in Check Kyc",err)

            Swal.fire({
                html: `
                    <p style="
                        font-size: 24px;
                        font-family: 'cardiuma-regular', sans-serif;
                        white-space: normal;
                        word-break: break-word;
                    ">
                        Somthing went wrong.Please try again later
                    </p>
                `, 
                icon: "error",
                willOpen: () => {
                    const swalContainer = document.querySelector(".swal2-container");
                    if (swalContainer) {
                        swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                    }
                },
            });
        }
        
    }


    useEffect(() => {// added by dev-kartik on 02-04-25
        (async () => {
            try {
                const payload = {
                    emailid: email,
                    mobileno: phone,
                };
              if(email.length !== 0 && phone.length !== 0){

                  const getData = await httpRequest({
                      endPoint: `${backendHosts.ADMIN}${apiUrl.getUser}`,
                      method: "post",
                      instance: "instanceOne",
                      requestBody: payload,
                  });

                  const result = getData.data
                  setUser(result);
              }
            } catch (error) {
                console.error("Error fetching client data:", error);
            }

        })();
    }, [aggregatorModal]);

    const imagesDoc=async()=>{
        try {
            console.log("id", id)
            const userData = await axios.get(`${backendHosts.ADMIN}${apiUrl.allUsersAndFilter}/${id}`)

            console.log("dataaaaaaaaaaaa", userData.data.data.data)
            let data = userData.data.data.data
            if (userData.data.data.status === 200) {
                setPicDetails({
                    aadhaar: {
                        data: data.aadhaar.data?.content,
                        verify: data.aadhaar.verified,
                    },
                    pan: {
                        data: data.pan.data?.content,
                        verify: data.pan.verified,
                    },
                    selfie: {
                        data: data.selfie.data?.content,
                        verify: data.selfie.verified,
                    },
                    signature: {
                        data: data.signature.data?.content,
                        verify: data.signature.verified,
                    },
                    account_opening_form: {
                        data: data.account_opening_form.data?.content,

                    },
                    cancelled_cheque: {
                        data: data.cancelled_cheque.data?.content,
                        verify: data.cancelled_cheque.verified,
                    },
                    fno_activation: {
                        data: data.fno_activation.data?.content,
                        verify: data.fno_activation?.verified,
                        type: data.fno_activation?.type,
                        password: data.fno_activation?.password
                    }
                }
                )




                

            }
            else {
                // srini - 11/11/24
                console.log('Error in Kyc Pending API', userData)
            }
        }
        catch (error) {
            // srini - 11/11/24
            console.log('Error in Kyc Pending API', error)
        }
    }

    

    // useEffect(() => {// added by dev-kartik on 02-04-25

       

    //     if (user.length > 0) {
    //         const fAndORecords = user.filter((record) => record.proof_type === "F&O" && record.archived === null);

    //         if (fAndORecords.length > 0) {
    //             const latestFAndORecord = fAndORecords.reduce((latest, record) =>
    //                 new Date(record.createdon) > new Date(latest.createdon) ? record : latest
    //             );

               
    //             const parts = latestFAndORecord.image_name.split("_");
    //             const yearIndex = parts.findIndex((part) => part.match(/^\d{4}$/)); // Find the index of the year
    //             const description = parts
    //                 .slice(yearIndex + 1, parts.length)
    //                 .join("_")
    //                 .replace(/\b\d{4}_/, "")
    //                 .replace(".pdf", "");

    //             if (description !== path) {
    //                 setPath(description);
    //             }
    //         } else {
    //             if (path !== "AA") {
    //                 setPath("AA");
    //             }
    //         }
    //     } else {
    //         if (path !== "AA") {
    //             setPath("AA");
    //         }
    //     }


    //     if (path == "AA" || path.includes("Bank_Statement")) {
    //         setDocType("Bank Statement")
    //     } else if (path.includes("Salary_Slip")) {
    //         setDocType("Salary Slip")
    //     }
    //     else if (path.includes("ITR")) {
    //         setDocType("IT Return")
    //     }
    //     else if (path.includes("Net_Worth")) {
    //         setDocType("Net Worth Certificate")
    //     } else if (path.includes("Demat_Statement")) {
    //         setDocType("Demat Account Holding Statement")
    //     } else {
    //         setDocType("Copy of last Form 16")
    //     }

    // }, [user, path]);

    const handleOpenAggregatorModal = () => {// added by dev-kartik on 02-04-25
        setAggregatorModal(true);
    };

    const handleCloseAggregatorModal = () => {// added by dev-kartik on 02-04-25
        setAggregatorModal(false);
        setFileName("");
        setDocumentType("Bank_Statement");
        setError("");
        setShow(false);
        setEnable(false);
    };

    const renderModalContent = () => {// added by dev-kartik on 02-04-25
        switch (uploadModalState.type) {
            case "aadhaar":
                return "Upload Aadhar";
            case "pan":
                return "Upload Pan";
            case "cancelled_cheque":
                return "Upload Cheque";
            case "selfie":
                return "Upload Selfie";
            case "signature":
                return "Upload Signature";
            default:
                return "Upload Document";
        }
    };

    
    const [fileName, setFileName] = useState("");
    
    const handleOpenUploadModal1 = (type) => {// added by dev-kartik on 02-04-25
        setUploadModalState({ open: true, type });
    };

    const handleCloseUploadModal1 = () => {// added by dev-kartik on 02-04-25
        setUploadModalState({ open: false, type: "" });
        setFileName("");
        setError("");
        setEnable(false);
    };

   

    const handlePicFile = async (file, type) => {// added by dev-kartik on 02-04-25
        if (!file) {
            console.error("No file selected.");
            setEnable(false);
            return;
        }

        const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validImageTypes.includes(file.type)) {
            setError("Invalid file type. Please upload an image (JPEG, PNG, JPG).");
            setFileName("");
            setEnable(false);
            return;
        }

        const maxSize = 5 * 1024 * 1024; // 1 MB
        if (file.size > maxSize) {
            setError("File size exceeds the 5MB limit.");
            setFileName("");
            setEnable(false);
            return;
        }

        try {
            const fileReader = new FileReader();
            fileReader.onload = async () => {
                try {
                    // FileReader provides a Base64-encoded string for image files
                    const base64Image = fileReader.result.split(",")[1];
                    // console.log(base64Image);
                    const data = `data:image/jpeg;base64,${base64Image}`;
                    setBaseData(data);
                    setEnable(true);
                    setError("");
                } catch (error) {
                    console.error("Error converting image to Base64:", error);
                }
            };

            fileReader.readAsDataURL(file); // Triggers Base64 encoding
        } catch (error) {
            console.error("Error reading file:", error);
            // setInccorectErr("Error reading the file.");
        }
        setFileName(file.name);
    };



    const convertBlobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const handlePdf = async (file) => {
        setFileName(file.name);
        setPassword("");
        setError("");

        const fsize = (file.size / (1024 * 1024)).toFixed(2);
        if (file.type !== "application/pdf") {
            setError("Invalid file format. Only PDF files are supported.");
            setEnable(false); 
            setBaseData("");
            return;
        }

        else if (fsize > 20) {
            setError("Max 20MB allowed.");
            setEnable(false);
            setBaseData("");
            return;
        }
      else{
        // const processFirstPage = async (pdfDoc) => { // dev-kartik 10-04-25
        //     try {
        //         const firstPage = await pdfDoc.getPage(1);
        //         const firstPageCanvas = document.createElement("canvas");
        //         const context = firstPageCanvas.getContext("2d");
        //         const viewport = firstPage.getViewport({ scale: 1 });

        //         firstPageCanvas.height = viewport.height;
        //         firstPageCanvas.width = viewport.width;

        //         await firstPage.render({ canvasContext: context, viewport }).promise;

        //         const base64PdfImage = firstPageCanvas.toDataURL("image/png");
        //         console.log("Canvas dimensions:", firstPageCanvas.width, firstPageCanvas.height);
        //         console.log("Base64 Data:", base64PdfImage.slice(0, 100));
        //         setBaseData(base64PdfImage)
        //         setShow(false);
        //         console.log("show", show);
        //         setEnable(true);

        //     } catch (error) {
        //         console.error("❌ Error extracting first page:", error);
        //         setError((prevState) => ({
        //             ...prevState,
        //             msg: "Failed to extract the first page of the PDF",
        //         }));
        //     }
        // };

        const processFile = async () => {
            console.log("PDF.js version running:", pdfjsLib.version);
            const fileReader = new FileReader();
            fileReader.onload = async () => {
                const pdfBytes = new Uint8Array(fileReader.result);
                let pdfDoc
          while(true){
                try {
                    const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
                     pdfDoc = await loadingTask.promise;

            
                    const base64Pdf = await convertBlobToBase64(new Blob([pdfBytes], { type: "application/pdf" }));
                    setBaseData(base64Pdf);
                    setEnable(true);
                    // await processFirstPage(pdfDoc);
                    break;
                } catch (error) {
                    if (error.message === "No password given") {
                        console.log("PDF is encrypted. Requesting password...");
                        setShow(true);
                        setEnable(false);
                        const enteredPassword = await new Promise((resolve, reject) => {
                            setpromise({ resolve, reject }); 
                        });

                        try {
                            const loadingTask = pdfjsLib.getDocument({
                                data: pdfBytes,
                                password: enteredPassword,
                            });

                            const decryptedPdfDoc = await loadingTask.promise;

                            console.log("Password is correct. Decrypting...");

                            const base64Pdf = await convertBlobToBase64(
                                new Blob([pdfBytes], { type: "application/pdf" })
                            );

                            //console.log("Base64 Encrypted PDF:", base64Pdf);
                            setShow(false);
                            setError("");
                            setFileName(file.name);
                            setBaseData(base64Pdf);
                            setEnable(true);
                            break; // Exit the loop if successful
                        } catch (decryptError) {
                            console.error(
                                "Incorrect password or unable to decrypt PDF:",
                                decryptError
                            );
                            setError("Incorrect password. Please try again.");
                        }
                    } else {
                        console.error("Error processing PDF:", error);
                        setError("Something went wrong. Please try again");
                        setEnable(false)
                        break; // Exit the loop for non-encryption errors
                    }
                }
            }
            };
            fileReader.readAsArrayBuffer(file);
        };

        await processFile();
    }
    };
    const handlePasswordSubmit = () => {
        if (password === "") {
            console.log("password", password);
            setError("Please Enter the Password");
        } else {
            console.log("password else", password);
            promise?.resolve(password);
            console.log(promise);
        }
    };

    const handleUpload = async (type) => {// added by dev-kartik on 02-04-25
        

        if (!baseData) {
            setError("No documents provided");
            return;
        }

        let payload = {
            data:{
            email: perData.email,
            mobile: perData.mobile,
            id:perData.user_id,
            type,
            base64:baseData,
            verified_by:"kartik"
           }
        };

        if (type === "AccountAggregator") {
            payload.data['fno_type'] =documentType; // New property name and value
            payload.data.type='fno_activation';
            payload.data['password'] = password || ""
        }

        console.log("payload",payload,typeof(perData.user_id))



        // if (uploadModal.type === "aadhar") {
        //     payload.aadharData = baseData;
        // } else if (uploadModal.type === "pan") {
        //     payload.panData = baseData;
        // } else if (uploadModal.type === "cheque") {
        //     payload.chequeData = baseData;
        // } else if (uploadModal.type === "selfie") {
        //     payload.selfieData = baseData;
        // } else if (uploadModal.type === "signature") {
        //     payload.signData = baseData;
        // } else {
        //     payload.bankStatmentData = baseData;
        // }


        try {

            const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.uploadDocument}`,payload)


            if (response.data.data.status === 200 && response.data.data?.data?.success ) {
               
                console.log("updatestate111",type)
                // const updatePicDetails = (type, baseData) => {
                //     // Change type to "fno_activation" if the input type is "AccountAggregator"
                //     if (type === "AccountAggregator") {
                //         type = "fno_activation";
                //     }

                //     // Update the picDetails state
                // //     setPicDetails((prevDetails) => {
                // //         return {
                // //             ...prevDetails, // Preserve the existing details
                // //             [type]: {
                // //                 ...prevDetails[type], // Preserve nested properties like 'verify'
                // //                 data: baseData, // Update the 'data' property
                // //             },
                // //         };
                // //     });
                // };
                // updatePicDetails(type, baseData)
                setBaseData("");
               
                imagesDoc()
                if (type === "AccountAggregator") {
                    handleCloseAggregatorModal();
                } else {
                    handleCloseUploadModal1(type);
                }


                Swal.fire({
                    html: `<h2 style="font-size: 24px; font-family: 'cardiuma-regular' !important;">
    Updated Successfully!
</h2>`,
                    icon: "success",
                    willOpen: () => {
                        const swalContainer = document.querySelector(".swal2-container");
                        if (swalContainer) {
                            swalContainer.style.zIndex = "2000";
                        }
                    },
                });
                return
            }
            Swal.fire({
                icon: "error",
                title: "Oops...",
                html: `<p style="font-size: 24px ; fontFamily:'cardiuma-regular', sans-serif !important;">${response.data.data?.data?.message}!</p>`,
                text: `!`,
                willOpen: () => {
                    const swalContainer = document.querySelector(".swal2-container");
                    if (swalContainer) {
                        swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                    }
                },
            });
        } catch (error) {
            console.log(error);
            console.log("error", error.message);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                html: `<p style="font-size: 24px ; fontFamily:'cardiuma-regular', sans-serif !important;">${error.message}!</p>`,
                text: `!`,
                willOpen: () => {
                    const swalContainer = document.querySelector(".swal2-container");
                    if (swalContainer) {
                        swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                    }
                },
            });
        }
    };

    dayjs.extend(relativeTime);
    const currentDate = dayjs();
    // Required values - Srini - 05-03-25
    const departmentName = localStorage.getItem('departmentName')
    const agentRole = JSON.parse(localStorage.getItem('agentRole'))

    const handleCollapsable = (id)=>{
        setOpenCol(opencol === id ? null : id);
    }
    const handleClick = (event) => {
        setPreview(true)
        setAnchorEl(event.currentTarget);
        setPreviewImg("")
        setPreviewText("")
    }
   
      const handleClose = () => {
        setAnchorEl(null);
        setPreview(false) 
        setPreviewText("")  
        setOpenCol(false)   //dev-trupti on 31-10-2024
        setRows([])  
        setPaymentHistory([])
        // setPreviewImg("")
      };
    
    const open = Boolean(anchorEl);
    //Showing Image on hover end by dev-trupti on 27-09-2024
    
    const handleChange = (e, value) => {
        setTabvalue(value)
        setCopyText('Copy')  //dev-trupti on 31-10-2024
        setOpenCol(false)
        setCopyText1('This PDF is encrypted click to copy the password!')
    }

    const handleImageDownload = (img, filename) => {
        const link = document.createElement('a');
        link.href = img
        link.download = filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const downloadPDF = (pdf, filename) => {
        let base64
        if (pdf.includes('data:application')){
            base64=pdf
        }else{
            base64 = `data:application/pdf;base64,${pdf}`
        }
        const linkSource = base64;
        const downloadLink = document.createElement("a");
        const fileName1 = filename
        downloadLink.href = linkSource;
        downloadLink.download = fileName1
        downloadLink.click();
    }
//Changed the download logic for preview start dev-trupti 22-10-2024
    const downloadAccOpenForm = async()=>{
        setLoader(true) 
       

    

        setPreviewImg(true)
        if (picDetails.account_opening_form.data){
            if (preview === true ) {
                setPreviewImg("")
                setPreviewText(perData.mobile + "_application.pdf");
                setLoader(false);
            } else if (download === true) {
                setIsaccform(false)
                const pdfname = perData.mobile + "_application.pdf"
                downloadPDF(picDetails.account_opening_form.data, pdfname)
                setLoader(false)
            }
    
        }else{
            setIsaccform(true)
                    handleClose()
                    setLoader(false)
        }
      

        // try{
           
        //     // const downloadData = await httpRequest({
        //     //     endPoint: `${backendHosts.ADMIN}${apiUrl.accoutOpen}`,
        //     //     method: "post",
        //     //     instance: "instanceOne",
        //     //     requestBody: payload,
        //     // })        
        //     // if(downloadData.status === 200) {
        //     //    
        //     // }else if(downloadData.error.statusCode===404 ){
        //     //     setIsaccform(true)
        //     //     handleClose()
        //     //     setLoader(false)
        //     //     // srini - 11/11/24
        //     //     console.log('Error in Accout Open API', downloadData)
        //     // }
        // }catch(error){
        //     // srini - 11/11/24
        //     console.log('Error in Account Open API', error)
        //     handleClose()
        //     setLoader(false)
        // }
        setLoader(false)
        setDownload(false)
    }
    const downloadAadhar = async()=>{
        setLoader(true)
        let filename = perData.mobile+"_"+aadhar+"_aadhar.jpg"
        
            if(preview === true) {
                setPreviewImg(picDetails.aadhaar) 
                setPreviewText(filename)
                setLoader(false)
            }
            else if(download === true){
                setIsaadhar(false)
                const image = filename
                handleImageDownload(picDetails.aadhaar,image) 
                setLoad(false)
            }
        // }
        // else if(downloadData?.error?.statusCode===404 ){
            // srini - 11/11/24
        //     console.log('Error in Aadhar API', downloadData)
        //     handleClose()
        //     setIsaadhar(true)
        //     setLoad(false)
        // }
        setDownload(false)
        setLoad(false)
}

    const downloadAccountAgregator = async () => {
        setLoader(true)
        let filename = phone + "_" + picDetails.fno_activation.type + ".pdf";// added by dev-kartik on 02-04-25
        let payload = {
            filename: filename
        }

        if (picDetails.fno_activation.data) {
            if (preview === true) {
                setPreviewImg("")
                setPreviewText(perData.mobile + '_' + picDetails.fno_activation.type+ "_application.pdf");
                setLoader(false);
            } else if (download === true) {
                // setIsaccform(false)
                const pdfname = perData.mobile + '_' + picDetails.fno_activation.type + "_application.pdf"
                downloadPDF(picDetails.fno_activation.data, pdfname)
                setLoader(false)
            }

        } else {
            setIsaa(true)
            handleClose()
            setLoader(false)
        }

        // const downloadData = await httpRequest({
        //     endPoint: `${backendHosts.ADMIN}${apiUrl.aa}`,
        //     method: "post",
        //     instance: "instanceOne",
        //     requestBody: payload
        // })
        // if (downloadData.status === 200) {
        //     if (preview === true) {
        //         setPreviewImg("");
        //         setPreviewText(prefix + accountnumber + "_" + path + ".pdf");// added by dev-kartik on 02-04-25
        //         setLoader(false);
        //     } else if (download === true) {
        //         console.log("false")
        //         setIsaa(false)
        //         let pdfname = ""
        //         pdfname = prefix + accountnumber + "_" + path + ".pdf";// added by dev-kartik on 02-04-25
        //         downloadPDF(downloadData.data, pdfname)
        //         setLoader(false)
        //     }
        // } 
        // else if (downloadData.error.statusCode === 404) {
        //     handleClose()
        //     setIsaa(true)
        //     setLoader(false)
        //     // srini - 11/11/24
        //     console.log('Error in AA API', downloadData)
        // }
        setDownload(false)
        setLoader(false)
    }


const downloadImages=(type)=>{
    setLoader(true)
    let filename = perData.mobile + "_"+ `${type}_.jpg`

    console.log("hellooo", type, download, preview)

    let data

    if (type == 'aadhar' && picDetails.aadhaar.data){
        data = picDetails.aadhaar.data
    } else if (type == 'pan' && picDetails.pan.data){
        data = picDetails.pan.data
    } else if (type == 'selfie' && picDetails.selfie.data) {
        data = picDetails.selfie.data
    } else if (type == 'sign' && picDetails.signature.data) {
        data = picDetails.signature.data
    } 
    else if (type == 'cancelled_cheque' && picDetails.cancelled_cheque.data) {
        console.log("caaaaaaaaa")
        data = picDetails.cancelled_cheque.data
    }
    else{
        console.log("else")
        if (type == 'cancelled_cheque' &&!picDetails.cancelled_cheque?.data) {
            console.log("else1")
            setIscancheque(true);
        }
        if (type == 'aadhar' && !picDetails.aadhaar?.data) {
            console.log("else2")
            setIsaadhar(true);
        }
        if (type == 'pan' &&!picDetails.pan?.data) {
            console.log("else3")
            setIspan(true);
        }
        if (type == 'selfie' &&!picDetails.selfie?.data) {
            console.log("else4")
            setIsselfie(true);
        }
        if (type == 'sign' &&!picDetails.signature?.data) {
            console.log("else5")
            setIssign(true);
        }
        handleClose()
        setLoad(false)
    }


    // if (picDetails?.cheque || picDetails?.aadhaar || picDetails?.pan || picDetails?.account_opening_form || picDetails?.signature )
    // {

  if(data){
    console.log("intooo data")
      if (preview === true) {
          setPreviewImg(data)
          setPreviewText(filename)
          setLoader(false)
      }
      else if (download === true) {
          setIsaadhar(false)
          const image = filename
          console.log("chequeData", data)
          handleImageDownload(data, image)
          setLoad(false)
      }

  }
      
       

    // }else{
    //     setIscancheque(true)
    //     setIsaadhar(true)
    //     setIspan(true)
    //     setIsselfie(true)
    //     setIssign(true)
    //     setLoader(true)
    //     setDownload(true)
    // }
    
    // }
    // else if(downloadData?.error?.statusCode===404 ){
    // srini - 11/11/24
    //     console.log('Error in Aadhar API', downloadData)
    //     handleClose()
    //     setIsaadhar(true)
    //     setLoad(false)
    // }
    setDownload(false)
    setLoad(false)
}

    
    const downloadPan = async()=>{
        setLoader(true)
        let filename = phone+"_"+aadhar+"_pan.jpg"
        let payload = {
            filename: filename
        }
        const downloadData = await httpRequest({
            endPoint: `${backendHosts.ADMIN}${apiUrl.pan}`,
            method: "post",
            instance: "instanceOne",
            requestBody:payload
        })        
        if(downloadData.status === 200) {
            if(preview === true) {
                setPreviewImg(downloadData.img) 
                setPreviewText(prefix+accountnumber+"_Pan.jpg")
                setLoader(false)
            }else if(download === true) {
                setIspan(false)
                const image = prefix+accountnumber+"_Pan.jpg"
                handleImageDownload(downloadData.img, image)
                setLoader(false)
            }
        }else if(downloadData.error.statusCode===404 ){
            handleClose()
            setIspan(true)
            setLoader(false)
            // srini - 11/11/24
            console.log('Error in PAN API', downloadData)
        }
        setDownload(false)
        setLoader(false)
    }

    const downloadCheque = async(str)=>{ //dev-trupti on 26-11-2024
        setLoader(true)
        let filename = perData.mobile+"_bankcheque.jpg"
        let payload = {
            filename: filename
        }
        const downloadData = await httpRequest({
            endPoint: `${backendHosts.ADMIN}${apiUrl.bankCheque}`,
            method: "post",
            instance: "instanceOne",
            requestBody:payload
        })        
        if(downloadData.status === 200) {
            if(preview === true) {
                setPreviewImg(downloadData.img)
                setPreviewText(prefix+accountnumber+"_Bank_cheque.jpg") 
                setLoader(false)
            }else if(download === true) {
                setIscancheque(false)
                const image = prefix+accountnumber+"_Bank_cheque.jpg"
                handleImageDownload(downloadData.img, image)
                setLoader(false)
            }
            else if(str ==='downloadBtn'){//dev-trupti on 26-11-2024
                const image = prefix+accountnumber+"_Bank_cheque.jpg"
                handleImageDownload(downloadData.img, image)
            }
        }else if(downloadData.error.statusCode===404 ){
            handleClose()
            setIscancheque(true)
            setLoader(false)
            // srini - 11/11/24
            console.log('Error in Bank Cheque API', downloadData)
        }
        setDownload(false)
        setLoader(false)
    }

    const downloadSelfie = async()=>{
        setLoader(true)
        let filename = phone+"_"+aadhar+"_selfie_image.jpg"
        let payload = {
            filename: filename
        }
        const downloadData = await httpRequest({
            endPoint: `${backendHosts.ADMIN}${apiUrl.selfie}`,
            method: "post",
            instance: "instanceOne",
            requestBody:payload
        })        
        if(downloadData.status === 200) {
            if(preview === true){
                setPreviewImg(downloadData.img) 
                setPreviewText(prefix+accountnumber+"_Selfie.jpg")
                setLoader(false)
            }else if(download === true){
                setIsselfie(false)
                const image = prefix+accountnumber+"_Selfie.jpg"
                handleImageDownload(downloadData.img, image)
                setLoader(false)
            }
        }else if(downloadData.error.statusCode===404 ){
            handleClose()
            setIsselfie(true)
            setLoader(false)
            // srini - 11/11/24
            console.log('Error in Selfie API', downloadData)
        }
        setDownload(false)
        setLoader(false)
    }
    const downloadSignature = async()=>{
        setLoader(true)
        let filename = phone+"_"+aadhar+"_sign.jpg"
        let payload = {
            filename: filename
        }
        const downloadData = await httpRequest({
            endPoint: `${backendHosts.ADMIN}${apiUrl.signature}`,
            method: "post",
            instance: "instanceOne",
            requestBody:payload
        })        
        if(downloadData.status === 200) {
            if(preview === true) {
                setPreviewImg(downloadData.img)
                setPreviewText(prefix+accountnumber+"_Signature.jpg") 
                setLoader(false)
            }else if(download === true){
                setIssign(false)
                const image = prefix+accountnumber+"_Signature.jpg"
                handleImageDownload(downloadData.img, image)
                setLoader(false)
            }
        }else if(downloadData.error.statusCode===404 ){
            handleClose()
            setIssign(true)
            setLoader(false)
            // srini - 11/11/24
            console.log('Error in Signature API', downloadData)
        }
        setDownload(false)
        setLoader(false)
    }
    
    

    const downloadPOA = async()=>{
        setLoader(true)
        let filename = phone+"_"+aadhar+"_poa.pdf"
        let payload = {
            filename: filename
        }
        const downloadData = await httpRequest({
            endPoint: `${backendHosts.ADMIN}${apiUrl.poa}`,
            method: "post",
            instance: "instanceOne",
            requestBody:payload
        })        
        if(downloadData.status === 200) {
            if(preview === true){
                setPreviewImg("");
                setPreviewText(prefix+accountnumber+"_POA.pdf")
                setLoader(false);
            }else if(download === true){
                setIsPoa(false)
                const pdfname = prefix+accountnumber+"_POA.pdf"
                downloadPDF(downloadData.data, pdfname)
                setLoader(false)
            }
        }else if(downloadData.error.statusCode===404 ){
            handleClose()
            setIsPoa(true)
            setLoader(false)
            // srini - 11/11/24
            console.log('Error in AA API', downloadData)
        }
        setDownload(false)
        setLoader(false)
    }

    //dev-trupti on 31-12-2024
    const downloadNri = async(filename, file)=>{
        let fileDownloadName = prefix + accountnumber
        setLoader(true)
        const extension = filename.split('.').pop().toLowerCase();
        let payload = {
            filename,
            extension
        }
        const downloadData = await httpRequest({
            endPoint: `${backendHosts.ADMIN}${apiUrl.nriImage}`,
            method: "post",
            instance: "instanceOne",
            requestBody:payload
        })        
        if(downloadData.status === 200) {
            if(file === "pis"){
                fileDownloadName = fileDownloadName + "_PIS."+extension
            }else if(file ==="nripan"){
                fileDownloadName = fileDownloadName + "_NRI_PAN."+extension
            }else if(file ==="identity"){
                fileDownloadName = fileDownloadName + "_Identity."+extension
            }else if(file ==="bankstatement"){
                fileDownloadName = fileDownloadName + "_Bank_statment."+extension
            }else if(file ==="communication"){
                fileDownloadName = fileDownloadName + "_Communication."+extension
            }
            if(preview === true){
                if(extension !== "pdf"){
                    setPreviewImg(downloadData.img);
                }else{
                    setPreviewImg("")
                }
                setPreviewText(fileDownloadName)
                setLoader(false);
            }else if(download === true){
                if(file === "pis"){
                    setIsNri({...nri, isPis:false})
                }else if(file ==="nripan"){
                    setIsNri({...nri, isPan:false})
                }else if(file ==="identity"){
                    setIsNri({...nri, isIdentity:false})
                }else if(file ==="bankstatement"){
                    setIsNri({...nri, isBankStatement:false})
                }else if(file ==="communication"){
                    setIsNri({...nri, isCommunication:false})
                }
                if(extension === "pdf"){
                    downloadPDF(downloadData.data, fileDownloadName)
                }else{
                    handleImageDownload(downloadData.img, fileDownloadName)
                }
                setLoader(false)
            }
        }else if(downloadData.error.statusCode===404 ){
            handleClose()
            if(file === "pis"){
                setIsNri({...isNri, isPis:true})
            }else if(file ==="nripan"){
                setIsNri({...isNri, isPan:true})
            }else if(file ==="identity"){
                setIsNri({...isNri, isIdentity:true})
            }else if(file ==="bankstatement"){
                setIsNri({...isNri, isBankStatement:true})
            }else if(file ==="communication"){
                setIsNri({...isNri, isCommunication:true})
            }
            setLoader(false)
            console.log('Error in NRI API', downloadData)
        }
        setDownload(false)
        setLoader(false)
    }
//Changed the download logic for preview end dev-trupti 22-10-2024

    const validateBank = async()=>{
        setLoad(true)
        if(acc && ifsc){
            const payload = {
                data: {
                id: id,
                account_number: acc,
                ifsc_code: ifsc,
                account_type: bankType
            }
          }
            try{
                const validateData = await axios.post(`${backendHosts.ADMIN}${apiUrl.chequeVerify}`,payload)
                if(validateData.data.data.status === 200){
                    setBankHolderName(validateData.data.data.data.account_name) 
                    setBankDetails(validateData.data.data.data)
                    setIsName(false)
                    setLoad(false) 
                }
                else{
                    // srini - 11/11/24
                    console.log('Error in Validate Bank API', validateData)
                }
                if(validateData.status===201){
                    setSnack(true)
                    setMsg("Something went wrong. Please try again after sometime")
                    setLoad(true)
                }
                else{
                    // srini - 11/11/24
                    console.log('Error in Validate Bank API', validateData)
                }
                setLoad(false)
            }catch(error){
               // srini - 11/11/24
                console.log('Error in Validate Bank API', error)
            }
        }else{
            setLoad(false)
            setSnack(true)
            setMsg("Please fill all the details correctly")
        }
        
    }

    const approve = async()=>{
        const payload = {
          data:{
            id:id,
            type:"cancelled_cheque",
            verified_by:'kartik',
            account_name: bankDetails?.account_name,
            account_number:bankDetails.account_number,
            ifsc:bankDetails?.bankDetails,
            account_type:bankDetails?.account_type,
            bank_address: bankDetails?.bank_address,
            branch_name: bankDetails?.branch_name,
            branch_name: bankDetails?.branch_name,
            micr_code: bankDetails?.micr_code,
            transaction_id: bankDetails?.transaction_id

          }
        }
        try{
            const updateData = await axios.post(`${backendHosts.ADMIN}${apiUrl.documentApprove}`,payload)
            if(updateData.data.data.status === 200){
                setLoaderstatus((prev)=>({...prev, type:'success', title:'Record Updated', content:'Record updated successfully', doctype:''}))
                // CompletedVerification(acc, ifsc, bankHolderName, {})
                setBankapproved({accno:acc, ifsc:ifsc, name:bankHolderName})
                setBankAccount(null)
                setBankDetails(null)
                setImage("")
                
                // const kycPayload = {
                //     emailid:email,
                //     mobileno:phone,
                //     type:0
                // }
                // const kyc = await httpRequest({
                //     endPoint: `${backendHosts.REG}${apiUrl.kyc}`,
                //     method: "post", 
                //     instance: "instanceOne",
                //     requestBody:kycPayload
                // })
                // if(kyc.status=== 200){
                //     setSnack(true)
                //     setMsg(`${kyc?.message}`)
                // }else{
                //     setSnack(true)
                //     setMsg("An error occured")
                //     console.log('Error in KYC API', kyc)
                // }
            }
            else{
                setLoaderstatus((prev)=>({...prev, type:'', title:'Error', content:'Something went wrong', doctype:''}))
                console.log('Error in Approve API', updateData)
            }
        }catch(error){
            console.log('Error in Validate Bank API', error)
        }
    }

    const reset = () => {
        handleEditModal()
        setTabvalue("1")
        setIsaccform(false)
        setIsaadhar(false)
        setIspan(false)
        setIscancheque(false)
        setIsselfie(false)
        setIssign(false)
        setIsaa(false)
        setIsPoa(false)
        setVerification("")
        setCreatedOn("")
        setData("")
        setYear("")
        setAcc("")
        setIfsc("")
        setImage("")
        setBankHolderName("")
        setIsName(true)
        setDisRepush(false)
        setSnack(false)
        setMsg("")
        setSelectedIndex(0) //dev-trupti on 22-10-2024
        setSelectedIndex1(0) 
        setIsNri({
            isPis : false,
            isPan:false,
            isIdentity : false,
            isBankStatement : false,
            isCommunication : false
        })
        setDocdata({})
        setVerify(false)
        setLoaderstatus({
            type:'confirm',
            title:'',
            content:'',
            doctype:''
        })
        setBankapproved({
            accno:'',
            ifsc:'',
            name:''
        }) 
        setDocstatus([])
        setRegData(null)
        setPerData(null)
        setDetailsData(details?.[0].type)
        setData(regData?.[0]?.data)
        setDetailsIndex(0)
        setOnBoardIndex(0)
        setOnBoardData("UserDetails")
        setDisableOcr(false)
        setAadhaarData({
            aadhaar_number: '',
            dob: '',
            fullName: '',
            state: '',
            district: '',
            pincode: '',
            address1: '',
            address2: '',
            city: ""
        })
        setAadhaarErrors({})
        setAadhaarAddress("")
        setSelectedIndex2(0)
        setResendError("")
        setresendSignError("")
    }  


    const handleAadhaarChange = (e) => {   
        const { name, value } = e.target;
        console.log(e.target.value,name)
        setAadhaarData(prev => ({ ...prev, [name]: value }));
    };


    const fetchOcrDetails = async (str) => {
        setLoad(true)
        // Converts YYYY-MM-DD → DD-MM-YYYY
        try {
            const payload = {
                data:{
                id,
                base64: picDetails.aadhaar?.data,
                type: str
                }
            }
            const ocrResponse = await axios.post(`${backendHosts.ADMIN}${apiUrl.ocr}`,payload)

            console.log("ddaa", ocrResponse?.data?.data?.data)
            if (ocrResponse?.data?.data?.data?.success === true) {
                const aadhaar_number = ocrResponse?.data?.data?.data?.data?.document_id
                const name = ocrResponse?.data?.data?.data?.data?.name || ''
                const address = ocrResponse?.data?.data?.data?.data?.address || ''

                console.log({
                    name,
                    aadhaar_number
                })
              
                // const lm = ocrResponse.data.address || ''
                setAadhaarData({
                    ...aadhaarData,
                    aadhaar_number,
                    fullName: name,
                })
                setAadhaarAddress(address)
                setDisableOcr(true)
                setLoad(false)
            } else {
                setLoad(false)
                setSnack(true)
                setMsg(ocrResponse?.data?.data?.data?.message)
            }
        } catch (error) {
            setLoad(false)
            setSnack(true)
            setMsg("An Error Occured. Please try again.")
            console.log("Error")
        }
    } 


    const validateAadhaarData = () => {
        const newErrors = {};
        const { aadhaar_number, fullName, pincode, district, state, city, address1 , address2 } = aadhaarData;

        console.log({
            aadh: aadhaar_number,
            fullName:fullName,
            pincode:pincode,
            dist:district,
            state: state, city, address1, address2: address2
        })

        const isValidAadhaarNumber = (aadhaar_number) => {
            const trimmed = aadhaar_number.replace(/\s+/g, '');

            // Full 12-digit Aadhaar
            if (/^\d{12}$/.test(trimmed)) return true;

            // Compact masked format only: XXXXXXXX1234
            if (/^X{8}\d{4}$/.test(trimmed)) return true;

            return false;
        };

        if (!aadhaar_number || !isValidAadhaarNumber(aadhaar_number)) {
            newErrors.aadhaar_number = "Enter a valid Aadhaar (12 digits or XXXXXXXX1234)";
        }

        if (!fullName.trim()) {
            newErrors.fullName = "Full name is required";
        }

        if (!pincode || !/^\d{6}$/.test(pincode)) {
            newErrors.pincode = "Enter a valid 6-digit Pincode";
        }

        if (!district.trim()) {
            newErrors.district = "District is required";
        }

        if (!state.trim()) {
            newErrors.state = "State is required";
        }

        if (!city.trim()) {
            newErrors.city = "City is required";
        }

        if (!address1.trim()) {
            newErrors.address1 = "Address1 is required";
        }

        if (!address2.trim()) {
            newErrors.address2 = "Address2  is required";
        }

        setAadhaarErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    //Added Preview start dev-trupti 22-10-2024
    useEffect(()=>{
        if(preview==true){
            if(hover === "accopening"){
                downloadAccOpenForm()
            }
             if(hover==="aadhar"){
                 downloadImages("aadhar")
             }
             else if(hover==="pan"){
                 downloadImages("pan")
             }
             else if (hover ==="cancelled_cheque"){
                 downloadImages("cancelled_cheque")
             }
             else if(hover==="selfie"){
                 downloadImages("selfie")
             }
             else if(hover==="sign"){
                 downloadImages("sign")
             }
             else if(hover==="aa"){
                 downloadAccountAgregator()
             }
             else if(hover==="poa"){
                downloadPOA()
            }
             else if(hover==="pis"){
                downloadNri(nri.pis_filename, hover)
             }
             else if(hover==="nripan"){
                downloadNri(nri.pan_filename, hover)
             }
             else if(hover==="identity"){
                downloadNri(nri.identity_filename, hover)
            }
            else if(hover==="bankstatement"){
                downloadNri(nri.bankstatment_filename, hover) 
            }
            else if(hover==="communication"){
                downloadNri(nri.communicationadd_filename, hover)
            }
        }
        if(download){
            if(hover ==="accopening"){
                downloadAccOpenForm()
            }
            if(hover==="aadhar"){
                downloadImages("aadhar")
            }
            else if(hover==="pan"){
                downloadImages("pan")
            }
            else if (hover ==="cancelled_cheque"){
                downloadImages("cancelled_cheque")
            }
            else if(hover==="selfie"){
                downloadImages("selfie")
            }
            else if(hover==="sign"){
                downloadImages("sign")
            }
            else if(hover==="aa"){
                downloadAccountAgregator()
            }
            else if(hover==="poa"){
                downloadPOA()
            }
            else if(hover==="pis"){
                downloadNri(nri.pis_filename, hover)
            }
            else if(hover==="nripan"){
                downloadNri(nri.pan_filename, hover)
            }
            else if(hover==="identity"){
                downloadNri(nri.identity_filename, hover)
            }
            else if(hover==="bankstatement"){
                downloadNri(nri.bankstatment_filename, hover) 
            }
            else if(hover==="communication"){
                downloadNri(nri.communicationadd_filename, hover)
            }
        }
     },[preview,download, hover])
    //Added Preview end dev-trupti 22-10-2024
    //dev-trupti on 17-12-2024
    const handleBankChange = (event)=>{
        setBankType(event.target.value);
    }

    const imgStyle = {
        position: "relative !important",
         top: "4px !important",
          marginLeft: "10px !important",
          justifyContent:'center !important' 
    }

    const style = {
        position: 'absolute !important',
        top: '50% !important',
        left: '50% !important',
        transform: 'translate(-50%, -50%) !important',
        width: '60% !important',
        // height:'60% !important',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius:'15px !important', //dev-trupti on 31-10-2024
        "@media only screen and (max-width: 1650px)": {
            width: '80% !important',
        },


      };

    // added by dev-kartik on 02-04-25
    const uploadModalStyle = {
        position: "absolute !important",
        top: "50% !important",
        left: "50% !important",
        transform: "translate(-50%, -50%) !important",
        width: "25% !important",
        height: fileName || error ? "28% !important" : "26% !important",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        borderRadius: "15px !important",
        "@media only screen and (max-width: 1650px)": {
            width: "35% !important",
            height: fileName || error ? "28% !important" : "26% !important",
        },

        "@media only screen and (max-height:800px)": {
            height: fileName || error ? "32% !important" : "30% !important",
        },

        "@media only screen and (max-height:730px)": {
            height:  "34% !important",
        },

        "@media only screen and (max-height:660px)": {
            height:  "37% !important",
        },

        "@media only screen and (max-height:630px)": {
            height: "40% !important",
        },

        "@media only screen and (max-height:570px)": {
            height: "44% !important",
        },
    };

    const aggregatorModalStyle = {
        position: "absolute !important",
        top: "50% !important",
        left: "50% !important",
        transform: "translate(-50%, -50%) !important",
        width: "25% !important",
        height: show ? "40% !important" : "32% !important",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        borderRadius: "15px !important",
        "@media only screen and (max-width: 1650px)": {
            width: "35% !important",
            height: show ? "40% !important" : "30% !important",
        },

        "@media only screen and (max-height:880px)": {
            height: show ? "44% !important" : "34% !important",
        },

        "@media only screen and (max-height:800px)": {
            height: show ? "46% !important" : "38% !important",
        },

        "@media only screen and (max-height:745px)": {
            height: show ? "50% !important" : "42% !important",
        },

        "@media only screen and (max-height:650px)": {
            height: show ? "52% !important" : "44% !important",
        },

        "@media only screen and (max-height:590px)": {
            height: show ? "54% !important" : "46% !important",
        },
    };

    const select = {
        color: "#000000 ",
        width: "160px ",
        fontFamily: "cardiuma-regular ",
    };

    const intSelText = {
        color: "#000000 !important",
        fontFamily: "cardiuma-regular ! important",
        fontSize: "14px ! important",
        fontWeight: 500,
    };

    const inputColor = {
        color: "#000000 !important",
        fontFamily: "cardiuma-regular ! important",
        fontSize: "14px ! important",
        fontWeight: 500,
    };
    
      const repushButton = {
        width: '120px !important',
        height: '38px !important',
        color: '#fff !important',
        backgroundColor: '#F44748 !important',
        fontSize: '13px !important',
        fontStyle: 'normal !important',
        fontFamily: "cardiuma-M !important",
        textTransform: "initial !important",
      }

    const selfieButton = {
        width: '180px !important',
        height: '38px !important',
        color: '#fff !important',
        backgroundColor: '#F44748 !important',
        fontSize: '13px !important',
        fontStyle: 'normal !important',
        fontFamily: "cardiuma-M !important",
        textTransform: "initial !important",
    }

      const disabledrepushButton = {
        width: '120px !important',
        height: '38px  !important',
        color:'#ffffff !important',
        backgroundColor: '#999999 !important',
        fontSize: '13px !important',
        fontStyle: 'normal !important',
        fontFamily: "cardiuma-M !important",
        textTransform: "initial !important",
      }

    const disableKycCheckButton = {
        width: '180px !important',
        height: '38px  !important',
        color: '#ffffff !important',
        backgroundColor: '#999999 !important',
        fontSize: '13px !important',
        fontStyle: 'normal !important',
        fontFamily: "cardiuma-M !important",
        textTransform: "initial !important",
    }

      const listItemStyle = {
        borderBottom:'0.5px solid #eeeeee',
         paddingBottom:'2px !important'
      }

      const downloadButton = {
        width:'150px',
        background: "#F74542 !important",
        padding: "10px 5px !important",
        fontStyle: "normal !important",
        fontSize: "11px !important",
        
        color: "#FFFFFF !important",
        textTransform: "initial !important",
        fontFamily: "cardiuma-M !important",
        float:'right !important',
        // marginRight:'16% !important', //dev-trupti on 17-12-2024
        marginBottom:"3px !important",
      }

      const buttons = {
        width:'150px',
        backgroundColor: "#F74542 !important",
        padding: "10px 5px !important",
        fontStyle: "normal !important",
        fontSize: "11px !important",
        // color: "#FFFFFF !important",
        textTransform: "initial !important",
        fontFamily: "cardiuma-M !important",
        marginLeft:'20px'
      }

      const buttondisabled = {
        width:'150px',
        backgroundColor: "#999999 !important",
        padding: "10px 5px !important",
        fontStyle: "normal !important",
        fontSize: "11px !important",
        color: "#FFFFFF !important",
        textTransform: "initial !important",
        fontFamily: "cardiuma-M !important",
        marginLeft:'20px'
      }

      const fontM = {
        fontFamily: "cardiuma-M !important"
      }
      
      const fontR = {
        fontFamily: "cardiuma-regular !important"
      }

    const fontB = {
        fontFamily: "cardiuma-Bold !important"
    }

      //dev-trupti on 31-10-2024
      const tableHeadStyle = {
        fontFamily: "cardiuma-SemiBold !important",
        fontSize:'16px !important',
        color:'#282828 !important',
        padding:'10px !important'
     
      }

      const tableSubHeadStyle = {
        fontFamily: "cardiuma-SemiBold !important",
        fontSize:'20px !important',
        color:'#282828 !important',
        padding:'20px !important'
     
      }

      const tableBodyStyle = {
        fontFamily: "cardiuma-regular !important",
        // padding:'0px !important'
      }

    //dev-trupti on 17-12-2024
      const infoGrid = {
        paddingLeft:'192px !important',
        "@media only screen and (max-width: 1400px)":{
            paddingLeft:'150px !important',
        },
        "@media only screen and (max-width: 1270px)":{
            paddingLeft:'100px !important',
        }
      }

    const alertbox = {
        display:'flex !important', 
        justifyContent:'center !important', 
        marginTop:'20px !important'
    }

    const dialogTitle = { 
        textAlign:'center !important', 
        paddingTop:'0px !important', 
        paddingBottom:'10px !important'
    }

    const dialogContentText =  {
        textAlign:'center !important', 
        padding:'0px 20px 10px 20px !important'
    }

    const dialogAction =  {
        display:'flex !important', 
        justifyContent:'center !important'
    }

    const disabledButton = {
        width: "100px !important",
        fontFamily: "cardiuma-M !important",
        fontSize: "14px !important",
        padding:'10px 20px 10px 20px !important',
        backgroundColor:'#999999 !important',
        color: "#ffffff !important",
    }

      const formatStage = (value) => {
        switch (value) {
            case 'Bank_verification':
                return 'Bank Verification';
            case 'REG_START':
                return 'Registration Start';
            case 'aadhaar verified':
                return 'Aadhaar Verified';
            case 'digilocker':
                return 'Digilocker';
            case 'OTP_SENT':
                return 'OTP Sent';
            case 'preferences':
                return 'Preferences';
            case 'qualification':
                return 'Qualification';
            case 'payment':
                return 'Payment';
            case 'docupload':
                return 'Document Upload';
            case 'liveliness':
                return 'Liveliness';
            case 'digilocker_adhar':
                return 'Digilocker Aadhaar';
            case 'liveness':
                return 'Liveness'
            case 'signature':
                return 'Signature';
            case 'exchange':
                return 'Exchange';
            case 'Nominee':
                return 'Nominee';
            case 'DIS':
                return 'DIS Status';
            case 'completed':
                return 'Completed';
            case 'pis_yes': //dev-trupti on 15-01-2025
                return 'PIS Yes';
            case 'pis_no':
                return 'PIS No';
            case 'nri':
                return 'NRI Upload'
            default:
                return value; // Fallback if no match
        }
    };

    const formatVerification = (value)=>{
        switch (value) {
            case 'nominee_aadhaar':
                return 'Nominee Aadhar';
            case 'otp':
                return 'OTP';
            case 'OTP':
                return 'OTP Aadhar';
            case 'pan verfy':
                return 'Pan Verify';
            case 'pan verfy1':
                return 'Pan to Name';
            case 'check_liveness':
                return 'Check Liveliness';
            case 'esignotp':
                return 'Esignotp';
            case 'aadhaar verfy':
                return 'Aadhaar verify';
            case 'verified':
                return 'Verified';
            case 'digilocker tocken':
                return 'Digilocker Token';
            case 'payment' :
                return 'Payment';
            case 'account_aggregator' :
                return 'Account Aggregator';
            //dev-trupti on 31-10-2024
            case 'Bank verfy' :  
                return 'Bank Verify';
            case 'Face verfy' :
                return 'Face Verify'
            default:
                return value
        }
    }

    // added copy + subscription table dev-trupti on 31-10-2024
    const handleCopy = ()=>{
        if(copyText==='Copy'){
            setCopyText('Copied')
        }
        navigator.clipboard.writeText(`Email - ${selectUser?.email}\n\nTime - ${createdOn}\n\nVerification - ${verification} \n\nJson Response - ${data}`);
    }

    const handleCopyEmail = () =>{
        if(copyText==='Copy'){
            setCopyText('Copied')
        }
        navigator.clipboard.writeText(perData?.email);
    }

    const handleCopyPassword = ()=>{
        if(copyText!=='Copied'){
            setCopyText1('Copied')
        }
        navigator.clipboard.writeText(`${picDetails.fno_activation?.password}`);
    }

    useEffect(()=>{
        if(subData){
             const mappedRows = [];

            if (subData.expertRecoData !== "user not found") {
                mappedRows.push({
                    id: "Expert Recommendation",
                    // name: `${subData?.expertRecoData?.name} ${subData?.expertRecoData?.clientid}`,
                    plan_Type: "Subscription",
                    plan_Status: subData?.expertRecoData?.subscription,
                    plan_end_date: subData?.expertRecoData?.subscription_end_date !=="" ? subData?.expertRecoData?.subscription_end_date : "NA",
                    plan_expires: dayjs(subData?.expertRecoData?.subscription_end_date).isBefore(dayjs()) ? "Expired" : (subData?.expertRecoData?.subscription_end_date === "" ? "NA" : dayjs(subData?.expertRecoData?.subscription_end_date).fromNow().replace(/^[a-z]/, (match) => match.toUpperCase())),
                    plan_amount: subData?.expertRecoData?.last_subscription_amount !=="" ? subData?.expertRecoData?.last_subscription_amount : "NA",
                });
                if(subData?.expertRecoData?.free_trial === true || subData?.expertRecoData?.free_trial_end_date !== ""){
                    mappedRows.push({
                        id: "Expert Recommendation",
                        // name: `${subData?.expertRecoData?.name} ${subData?.expertRecoData?.clientid}`,
                        plan_Type: "Free Trial",
                        plan_Status: subData?.expertRecoData?.free_trial,
                        plan_end_date: subData?.expertRecoData?.free_trial_end_date !=="" ?  subData?.expertRecoData?.free_trial_end_date : "NA",
                        // plan_expires: subData?.expertRecoData?.free_trial_end_date !=="" ?  (dayjs().isBefore(dayjs(subData?.expertRecoData?.free_trial_end_date)) ? "Expired" : dayjs(subData?.expertRecoData?.free_trial_end_date).fromNow().replace(/^[a-z]/, (match) => match.toUpperCase())): "NA",
                        plan_expires: subData?.expertRecoData?.free_trial_end_date !=="" ?  (dayjs(subData?.expertRecoData?.free_trial_end_date).isBefore(dayjs()) ? "Expired" : dayjs(subData?.expertRecoData?.free_trial_end_date).fromNow().replace(/^[a-z]/, (match) => match.toUpperCase())): "NA",
                        plan_amount: "FREE",
                    });
                }
            }

            if (subData.wealthvaultData !== "user not found") {
                mappedRows.push({
                    id: "Wealth Vault",
                    // name: `${subData?.wealthvaultData?.name} ${subData?.wealthvaultData?.clientid}`,
                    plan_Type: "Subscription",
                    plan_Status: subData?.wealthvaultData?.subscription,
                    plan_end_date: subData?.wealthvaultData?.subscription_end_date !=="" ? subData?.wealthvaultData?.subscription_end_date : "NA",
                    plan_expires: dayjs(subData?.wealthvaultData?.subscription_end_date).isBefore(dayjs())? "Expired" : (subData?.wealthvaultData?.subscription_end_date ==="" ? "NA" : dayjs(subData?.wealthvaultData?.subscription_end_date).fromNow().replace(/^[a-z]/, (match) => match.toUpperCase())),
                    plan_amount: subData?.wealthvaultData?.last_subscription_amount !=="" ? subData?.wealthvaultData?.last_subscription_amount : "NA",
                });
            }
            setRows(mappedRows)
            setPaymentHistory(subData?.wealthvaultData?.transactionData)
            
        }
    },[subData])

    useEffect(()=>{ //useeffect added by dev-trupti on 15-01-2025
    const timestamp = selectUser?.updated_on
    const date = new Date(timestamp)
    const year = date.getFullYear().toString()
    let finalYear = ''
        if(year.length > 0){
        setYear(year)
        finalYear = year
        }else{
        const currentYear = dayjs().year().toString()
        setYear(currentYear)
        finalYear = currentYear
    }

    const fetchData = async (doc) => {
        const formPayload = async(ele) => {
            let filename = '';
            if (ele === 'aadhar') {
                filename = phone + "_" + aadhar + "_aadhar.jpg";
            } else if (ele === 'pan') {
                filename = phone + "_" + aadhar + "_pan.jpg";
            }
            else if (ele === 'selfie') {
                filename = phone + "_" + aadhar + "_selfie.jpg";
            } else if (ele === 'cheque') {
                filename = phone + "_" + aadhar + "_bankcheque.jpg";
            } else if (ele === 'bankstatement') {
                  let result
                try {

                    const payload = {
                        emailid: email,
                        mobileno: phone,
                    };

                    const getData = await httpRequest({
                        endPoint: `${backendHosts.ADMIN}${apiUrl.getUser}`,
                        method: "post",
                        instance: "instanceOne",
                        requestBody: payload,
                    });


                    let user = getData.data
                    if (user.length > 0) {
                        const fAndORecords = user.filter((record) => record.proof_type === "F&O" && record.archived === null);

                        if (fAndORecords.length > 0) {
                            const latestFAndORecord = fAndORecords.reduce((latest, record) =>
                                new Date(record.createdon) > new Date(latest.createdon) ? record : latest
                            );


                            const parts = latestFAndORecord.image_name.split("_");
                            const yearIndex = parts.findIndex((part) => part.match(/^\d{4}$/)); // Find the index of the year
                            const description = parts
                                .slice(yearIndex + 1, parts.length)
                                .join("_")
                                .replace(/\b\d{4}_/, "")
                                .replace(".pdf", "");

                                result=description

                        } else {
                          result="AA"
                        }
                    } else {
                        result = "AA"
                    }

                } catch (err) {
                    console.error("Error fetching data:", err);
                }

                filename = phone + "_" + aadhar + "_" + year + "_" + result + ".pdf"; // added by dev-kartik on 02-04-25
            }
            return { filename };
        };

        const formUrl = (ele) => {
            let url = '';
            if (ele === 'aadhar') {
                url = `${backendHosts.ADMIN}${apiUrl.aadhar}`;
            } else if (ele === 'pan') {
                url = `${backendHosts.ADMIN}${apiUrl.pan}`;
            } else if (ele === 'cheque') {
                url = `${backendHosts.ADMIN}${apiUrl.bankCheque}`;
            } 
            else if (ele === 'selfie') {
                url = `${backendHosts.ADMIN}${apiUrl.selfie}`;
            } else if (ele === 'bankstatement') {
                url = `${backendHosts.ADMIN}${apiUrl.aa}`;
            }
            return url;
        };


        try {

            const filename= await formPayload(doc)

            const downloadData = await httpRequest({
                endPoint: formUrl(doc),
                method: "post",
                instance: "instanceOne",
                requestBody: filename,
            });

            if (downloadData.status === 200) {
                setDocdata(prevState => ({
                    ...prevState,
                    [doc]: doc === 'bankstatement'? downloadData.data : downloadData.img
                }));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchDocs = async () => {
        try {
            await Promise.all(docstatus?.map((ele) => fetchData(ele)));
        } catch (error) {
            console.error("Error fetching documents", error);
        }
    };

    if(!verify){ //To not let it fecth during Approvals
        fetchDocs();
    }
    setViewdata(docstatus[0])

    },[selectUser, docstatus])

    const decodeBase64 = (str) =>{
        console.log("inside decode",str)
        const key = "96358214256984120"
        if(str){
            console.log("strrrr",str,key)
            let decrypted = CryptoJS.AES.decrypt(str, key).toString(CryptoJS.enc.Utf8);
            return decrypted
        }else{
            return 'Not Available'
        }
    }

    

    const verificationDownload = (str) => {
        if(str === 'aadhar'){
            let filename = perData.mobile+"_Aadhaar.jpg"
            const imageData = picDetails.aadhaar?.data
            handleImageDownload(imageData,filename) 
        }
        else if(str === 'pan'){
            let filename = perData.mobile +"_Pan.jpg"
            const imageData = picDetails.pan?.data
            handleImageDownload(imageData,filename) 
        }else if(str == "selfie"){
            let filename = perData.mobile + "_selfie.jpg"
            const imageData = picDetails.selfie?.data
            handleImageDownload(imageData, filename)
        }
        else if (str == "signature"){
            let filename = perData.mobile + "_sign.jpg"
            const imageData = picDetails.signature?.data
            handleImageDownload(imageData, filename)
        }
        else if (str === 'cancelled_cheque'){
            let filename = perData.mobile + "_cancelled_cheque.jpg"
            const imageData = picDetails.cancelled_cheque?.data
            handleImageDownload(imageData, filename) 

        } else if (str === 'fno_activation'){
            let filename = perData.mobile+ "_" + picDetails?.fno_activation?.type + ".pdf" // added by dev-kartik on 02-04-25
            const pdfData = picDetails?.fno_activation?.data
            downloadPDF(pdfData, filename)
        }
    }

    const uploadDoc = (str) => {
        setUploadmodal((prev)=>({...prev, open:true, type:str}))
    }

    const closeModal = () => {
        setUploadmodal((prev)=>({...prev, open:false, type:''}))
    }

    const confirmDialog = (str) => {
        setLoaderstatus((prev)=>({...prev, type:'confirm', title:'Update record?', content:'Please click on OK to update the record', doctype:str}))
        setDocloader(true)
    }

    const updateDocStatus = (obj, key, value) => {  //Function to make the approved documents false
        if (obj.hasOwnProperty(key)) {
            obj[key] = value;
          } else {
            console.log("Key does not exist in the object.");
          }
          return obj;
    }


    const approveAadhaar =async(str)=>{
         const payload={
            data:{
                id,
                type:"aadhaar",
                verified_by:username,
                aadhaar_number:aadhaarData.aadhaar_number,
                aadhaar_full_name:aadhaarAddress.name,
                address:{
                    type:"manual",
                    house:aadhaarData.address1,
                    lm:aadhaarData.address2,
                    dist:aadhaarData.district,
                    vtc:aadhaarData.city,
                    state:aadhaarData.state,
                    pc:aadhaarData.pincode,
                    country:"India"
                 }
            }
         }

         console.log("payload",payload)

        const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.documentApprove}`,payload)
        if (response.data.data.status === 200 && response.data?.data?.data.success) {
            setLoaderstatus((prev) => ({ ...prev, type: 'success', title: 'Record Updated', content: 'Record updated successfully', doctype: '' }))
            // CompletedVerification(acc, ifsc, bankHolderName, {})
            setAadhaarData({
                aadhaar_number: '',
                dob: '',
                fullName: '',
                state: '',
                district: '',
                pincode: '',
                address1: '',
                address2: '',
                city: ""
            })
        }
        else {
            setLoaderstatus((prev) => ({ ...prev, type: '', title: 'Error', content: 'Something went wrong', doctype: '' }))
            console.log('Error in Approve API', response)
        }
    }

    const approveDocs = async(str) => {
        if(str === ''){
            setDocloader(false) 
        }else{
            setLoaderstatus((prev)=>({...prev, type:'load', title:'Loading', content:'Please wait', doctype:''}))
            let payload
            if (str === 'cancelled_cheque'){
                // approve()
                payload = {
                    data: {
                        id: id,
                        type: "cancelled_cheque",
                        verified_by: username,
                        account_name: bankDetails?.account_name,
                        account_number: bankDetails.account_number,
                        ifsc: bankDetails?.ifsc,
                        account_type: bankDetails?.account_type,
                        bank_address: bankDetails?.bank_address,
                        branch_name: bankDetails?.branch_name,
                        bank_name: bankDetails?.bank_name,
                        micr_code: bankDetails?.micr_code,
                        transaction_id: bankDetails?.transaction_id
                    }
                }
            } else if (str === 'aadhaar'){
                // approveAadhaar()
                payload = {
                    data: {
                        id,
                        type: "aadhaar",
                        verified_by: username,
                        aadhaar_number: aadhaarData?.aadhaar_number,
                        aadhaar_full_name: aadhaarData?.fullName,
                        address: {
                            type: "manual",
                            house: aadhaarData.address1,
                            lm: aadhaarData.address2,
                            dist: aadhaarData.district,
                            vtc: aadhaarData.city,
                            state: aadhaarData.state,
                            pc: aadhaarData.pincode,
                            country: "India"
                        }
                    }
                }
               
            }else{
                payload = {
                    data: {
                        id: id,
                        type: str,
                        verified_by: username
                    }
                }
            }
           
            const userId = localStorage.getItem('user_id1')
            const document_status = updateDocStatus(docobj, str, 'approved')

            
            try {
                const updateData = await axios.post(`${backendHosts.ADMIN}${apiUrl.documentApprove}`,payload)
                if(updateData.data.data.status === 200){
                    if (str == 'cancelled_cheque'){
                        setBankAccount(null)
                        setBankDetails(null)
                        setImage("")
                    }
                    else if(str == 'aadhaar'){
                        setAadhaarData({
                            aadhaar_number: '',
                            dob: '',
                            fullName: '',
                            state: '',
                            district: '',
                            pincode: '',
                            address1: '',
                            address2: '',
                            city: ""
                        })
                    }
                    const updatedarray = docVerification.filter((ele)=>{
                        if(ele !== str){
                            return ele
                        }
                    })
                    setVerify(true)
                    setDocVerification(updatedarray)
                    // CompletedVerification('', '', '', document_status )
                    setSelectedIndex1(0)
                    setLoaderstatus((prev)=>({...prev, type:'success', title:'Record Updated', content:'Record updated successfully', doctype:''}))
                    if(updatedarray.length === 0){
                        const kycPayload = {
                            data:{
                                id
                            }
                        }
                        const kyc = await axios.post(`${backendHosts.ADMIN}${apiUrl.repush}`,kycPayload)
                        console.log('repush',kyc.data.data.data)
                        if(kyc.data.data.status=== 200){
                            setSnack(true)
                            setMsg(`${kyc.data.data.data?.message}`)
                        }else{
                            setSnack(true)
                            setMsg("An error occured")
                            console.log('Error in KYC API', kyc)
                        }
                    }
                }else{
                    console.log("elseApproves")
                    setSnack(true)
                    setMsg("An error occured")
                }
            } catch (error) {
                console.log("catch")
                console.error("Error fetching data:", error);
                setSnack(true)
                setMsg("An error occured")
            }
        }
        
    }

    
    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'mobileno', headerName: 'Mobile No', width: 130 },
        { field: 'clientid', headerName: 'Client ID', width: 130 },
        {
          field: 'subscription',
          headerName: 'Subscription',
          width: 130,
          renderCell: (params) => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {params.value ? (
                <CheckIcon style={{ color: 'green' }} />
              ) : (
                <CloseIcon style={{ color: 'red' }} />
              )}
              {/* <span style={{ marginLeft: 5 }}>
                {params.value ? 'Active' : 'Inactive'}
              </span> */}
            </div>
          ),
        },
        { field: 'subscription_end_date', headerName: 'Subscription End Date', width: 180 },
        { field: 'last_subscription_amount', headerName: 'Last Subscription Amount', width: 180 },
      ];

    return (
        <>
        <Modal open={editModal}  onClose={reset}>
            <Box  sx={style}>
            {load &&
            // dev-trupti on 22-10-2024
                <Box  sx={{display:'flex', zIndex:'1',position:'absolute', top:'45%', left:'50%', backgroundColor:'transparent'}}> 
        <CircularProgress size={55}/>
        </Box>}
            <Grid sx={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <Tabs sx={{fontFamily: "cardiuma-Bold !important"}} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile value={tabvalue} onChange={handleChange} >
                <Tab label={<Typography sx={fontM}>User Details</Typography>} value="1" />
                          
                    <Tab label={<Typography sx={fontM}>Download Images</Typography>}value="2" />
                    {perData?.kyc_status !== 'in_progress' && <Tab label={<Typography sx={fontM}>Document Verification</Typography>} value="3" />}
                    {regData?.length !== 0 && <Tab label={<Typography sx={fontM}>API Responses</Typography>} value="4" />}
                    {/* <Tab label={<Typography sx={fontM}>Subscriptions</Typography>} value="5" />  */}
                    {perData?.kyc_status == 'completed_bo_pending' && <Tab label={<Typography sx={fontM}>User onboarding Deatils</Typography>} value="6" />}
                    {perData?.kyc_status == 'completed' && <Tab label={<Typography sx={fontM}>FNO Activation</Typography>} value="7" />} 
                            <Tab label={<Typography sx={fontM}>Resend KYC Link</Typography>} value="8" />
                    {/* { <Tab label={<Typography sx={fontM}>FNO Activation</Typography>} value="7" />} */}
                     
                </Tabs>
                <IconButton onClick={reset} style={{ float: "right", position: "relative", color: "#00acfe" }}>
                <CloseIcon />
                </IconButton>
            </Grid>
            
            {
                tabvalue==="1" && 
                        <Box sx={{
                            margin: '20px 0px 0px 130px !important', display: 'flex !important', height: '479px !important', overflowY: 'auto !important', border: '0.5px solid #eeeeee', borderRadius: '15px !important',
                            '&::-webkit-scrollbar': {
                                width: '5px',
                            },

                            '&::-webkit-scrollbar-thumb': {
                                width: '5px',
                                background: '#bbbbbb'
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#dddddd'
                            }
                        }}>
                            <Drawer
                                sx={{
                                    width: '90px',
                                    flexShrink: 0,
                                    '& .MuiDrawer-paper': {
                                        border: '0.5px solid #eeeeee',
                                        //dev-trupti on 31-10-2024
                                        borderRadius: '15px !important',
                                        boxSizing: 'border-box',
                                        marginTop: '100px !important',
                                        marginLeft: '30px !important',
                                        height: '482px !important',
                                        width: '250px !important'
                                    },
                                    '& .css-12i7wg6-MuiPaper-root-MuiDrawer-paper': {
                                        overflowX: 'auto !important',
                                        '&::-webkit-scrollbar': {
                                            width: '5px',
                                            height: '8px',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            width: '5px',
                                            background: '#bbbbbb'
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#dddddd'
                                        }
                                    }
                                }}
                                variant="permanent"
                                anchor="left"
                            >
                                <List>
                                  
                                        {details?.map((ele, index) => (
                                        <ListItem key={index} disablePadding>
                                            
                                            <ListItemButton
                                                sx={{ backgroundColor: detailsIndex === index && '#f2d0d0 !important' }}
                                                selected={detailsIndex === index}
                                                onClick={() => {
                                                   

                                                    if(ele.type === "NomineeDetails"){
                                                        const aadhaar = decodeBase64(ele?.nominee_aadhaar)
                                                        ele.nominee_decoded_aadhaar = aadhaar.slice(-5, -1)
                                                    }

                                               
                                                    setDetailsIndex(index)
                                                    // setCreatedOn(ele.createdAt)
                                                    setDetailsData(ele);
                                                    setVerification(ele.type)
                                                    //dev-trupti on 31-10-2024
                                                    setCopyText('Copy Response')
                                                }}
                                            >
                                                   
                                              
                                                <ListItemText 
                                                   primary={formatVerification(ele.type)}
                                                    primaryTypographyProps={fontM}
                                                />
                                               
                                                    {ele.status && ( // Conditionally render the icon based on ele.status
                                                        <ListItemIcon>
                                                            <img src={verified} alt="icon" />
                                                        </ListItemIcon>
                                                    )}
                                                
                                                    
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                            </Drawer>
                            <Box
                                    sx={{ bgcolor: 'background.default', margin: '10px 10px 0px 50px !important', width: '950px', display: 'flex', flexDirection: 'row', justifyContent: 'center', textAlign: 'center' , wordBreak: 'break-word' }}
                            >
                                
                                <Grid mt={2} mb={2} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center' }}>
                                    {/* <Typography sx={fontM} mr={1}>Creation Date - {createdOn && dayjs(createdOn).format('DD/MM/YYYY hh:mm:ss')}</Typography> */}
                                    {/* <Tooltip title={<Typography fontSize={12} sx={fontM}>{copyText1}</Typography>}>
                                        <IconButton onClick={handleCopy}>
                                            <ContentCopyIcon />
                                        </IconButton>
                                    </Tooltip> */}
                                </Grid>
                                {/* <Typography sx={fontM} >  </Typography> */}
                                <Grid mt={1} >
                                        {/* <Typography sx={{ fontFamily:"cardiuma-M",fontSize:"20px"}} mt={2} >{detailsData?.type || detailsData }</Typography> */}
                                      

                                            {/* {(detailsData?.type === 'BankDetails' && detailsData?.verification_type == 'Traditional' && detailsData?.status || detailsData?.type === 'BankDetails' && detailsData?.verification_type == 'Manual' && detailsData?.account_number && detailsData?.status) &&
                                            <> 
                                            <Grid container sx={{ padding: '20px 0px 0px 60px !important', display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                                <Grid>
                                                    <Typography mb={2.5} sx={{ paddingRight: '20px !important', fontFamily: "cardiuma-M" }}>Full Name:</Typography>
                                                    <Typography mb={2.5} sx={fontM}>Account No:</Typography>
                                                    <Typography mb={3} sx={fontM}>IFSC Code:</Typography>
                                                    <Typography mb={3} sx={fontM}>Account Type:</Typography>
                                                    <Typography mb={3} sx={fontM}>Micr Code:</Typography>
                                                    <Typography mb={3} sx={fontM}>Bank Name:</Typography>
                                                    <Typography mb={3} sx={fontM}>Bank Address:</Typography>


                                                </Grid>

                                    

                                            <Grid>
                                                
                                                <Typography mb={2.5} sx={fontM}>{detailsData?.account_name}</Typography>
                                                <Typography mb={3} sx={fontM}>{detailsData?.account_number}</Typography>
                                                <Typography mb={3} sx={fontM}>{detailsData?.ifsc_code}</Typography>
                                                <Typography mb={3} sx={fontM}>{detailsData?.account_type}</Typography>
                                                <Typography mb={3} sx={fontM}>{detailsData?.micr_code}</Typography>
                                                <Typography mb={2.6} sx={fontM}>{detailsData?.bank_name}</Typography>
                                                <Typography mb={2} ml={3} sx={fontM}>{`${detailsData?.branch_name} ${detailsData?.bank_address}`}</Typography>



                                            </Grid>
                                        </Grid>
                                                    </>
                                            } */}

                                        {
                                            (detailsData?.type === 'AadhaarDetails' && !detailsData.status) &&
                                            <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still user didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            (detailsData?.type === 'AadhaarDetails' && detailsData.status) &&
                                            <>
                                                <Grid container sx={{ justifyContent: 'center', paddingTop: '100px' }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse", minWidth: 500 }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>AaddharNo</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                    {detailsData?.aadhaarNo
                                                                        ? detailsData.aadhaarNo.slice(-3 - 1)
                                                                        : "Not Available"}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Aadhar verify</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                    {JSON.stringify(detailsData?.verified)}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'PanDetails' && !detailsData.status) &&
                                            <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important",textTransform:"capitalize" }}>
                                                        Still user didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            (detailsData?.type === 'PanDetails' && detailsData.status) &&
                                            <>
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 120,
                                                        right: 60,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>

                                                <Grid container sx={{ justifyContent: 'center', paddingTop: '100px' }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse", minWidth: 500 }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>PanNo</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                    {detailsData?.panNo
                                                                        ? detailsData.panNo
                                                                        : "Not Available"}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Pan verify</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                    {JSON.stringify(detailsData?.verified)}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }



                                        {(
                                            (detailsData?.type === 'BankDetails' && detailsData?.verification_type === 'Traditional' && detailsData?.status) ||
                                            (detailsData?.type === 'BankDetails' && detailsData?.verification_type === 'Manual' && detailsData?.account_number && detailsData?.status)
                                        ) && (

                                            <>
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 110,
                                                        right: 60,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>
                                                <Grid container sx={{ justifyContent: "center", paddingTop: "20px" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse", minWidth: 500 }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Full Name</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.account_name}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Account No</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.account_number}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>IFSC Code</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.ifsc_code}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Account Type</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.account_type}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>MICR Code</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.micr_code}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Bank Name</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.bank_name}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Bank Address</TableCell>
                                                                <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                    {`${detailsData?.branch_name || ''} ${detailsData?.bank_address || ''}`}
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                                
                                            )}


                                            {
                                                (detailsData?.type === 'BankDetails' && detailsData?.verification_type == 'Manual' && detailsData?.status && !detailsData?.account_number) &&<>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Document needs To Be Verified
                                                    </Typography>
                                                </Grid>
                                                </>
                                            }

                                        {
                                            (detailsData?.type === 'BankDetails' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%',height:"80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important",textTransform: "capitalize" }}>
                                                    Still User didn't attempted this step
                                                </Typography>
                                                </Grid>
                                            </>
                                        }



                                        {
                                            detailsData?.type === 'NomineeDetails' &&
                                            detailsData?.status &&
                                            !detailsData?.nominee_skip && (

                                                <>

                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            top: 110,
                                                            right: 80,
                                                        }}
                                                    >
                                                        <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                    </Box>
                                                    <Grid container sx={{ justifyContent: "center", paddingTop: "20px" }}>
                                                        <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse", minWidth: 500 }}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                    <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Nominee Name</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.nominee_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Nominee DOB</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.nominee_dob}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Nominee Relation</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.nominee_relation}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Nominee Aadhaar No</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                        {detailsData?.nominee_decoded_aadhaar
                                                                            ? detailsData.nominee_decoded_aadhaar.slice(-5 - 1)
                                                                            : "Not Available"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Nominee Pincode</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.nominee_pincode}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Grid>
                                                </>
                                                
                                            )
                                        }


                                            {
                                                (detailsData?.type === 'NomineeDetails' && detailsData.status && detailsData?.nominee_skip ) &&
                                                <>
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 130,
                                                        right: 80,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Nominee Step Skiped
                                                    </Typography>
                                                </Grid>
                                                </>
                                            }

                                        {
                                            (detailsData?.type === 'NomineeDetails' && !detailsData.status ) &&
                                            <>
                                                <Grid sx={{ width: '100%',height:"80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                    Still User didn't attempted this step
                                                </Typography>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            detailsData?.type === 'PersonalDetails' &&
                                            detailsData?.status && (
                                                <>

                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            top: 110,
                                                            right: 70,
                                                        }}
                                                    >
                                                        <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                    </Box>
                                                    <Grid container sx={{ justifyContent: "center", paddingTop: "20px" }}>
                                                        <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse", minWidth: 500 }}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                    <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Gender</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.gender}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Marital Status</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.marital_status}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Guardian</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.guardian}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Occupation</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.occupation}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Annual Income</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.annual_income}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Investment Experience</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.investment_exp}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Qualification</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{detailsData?.qualification}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Grid>
                                                    </>
                                               
                                            )
                                        }


                                           
                                        {
                                            (detailsData?.type === 'PersonalDetails' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still User didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }

                                        
                                        {
                                            detailsData?.type === 'SegmentDetails' &&
                                            detailsData?.status && (

                                                <>
                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            top: 120,
                                                            right: 80,
                                                        }}
                                                    >
                                                        <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                    </Box>
                                                    <Grid container sx={{ justifyContent: 'center', paddingTop: '70px' }}>
                                                        <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse", minWidth: 500 }}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                    <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Commodity</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                        {JSON.stringify(detailsData?.commodity)}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Currency</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                        {JSON.stringify(detailsData?.currency)}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>Equity</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                        {JSON.stringify(detailsData?.equity)}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>FandO</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>
                                                                        {JSON.stringify(detailsData?.fando)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Grid>
                                                </>
                                                
                                            )
                                        }


                                     {
                                            (detailsData?.type === 'SegmentDetails' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still User didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'Signature' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still User didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'Signature' && detailsData?.status) && <>

                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 120,
                                                        right: 80,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        User Completed this Step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }



                                        {
                                            (detailsData?.type === 'Selfie' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still User didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'Selfie' && detailsData?.status) && <>

                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 130,
                                                        right: 80,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        User Completed this Step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            (detailsData?.type === 'DIS Slip' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still User didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'DIS Slip' && detailsData?.status) && <>

                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 130,
                                                        right: 80,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        User Completed this Step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'Esign' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still User didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'Esign' && detailsData?.status) && <>

                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 130,
                                                        right: 80,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        User Completed this Step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'Payment' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still User didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'Payment' && detailsData?.status) && <>

                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 130,
                                                        right: 80,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        User Completed this Step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }



                                        {
                                            (detailsData?.type === 'Congrats Page' && !detailsData?.status) && <>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        Still User didn't attempted this step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            (detailsData?.type === 'Congrats Page' && detailsData?.status) && <>

                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 130,
                                                        right: 80,
                                                    }}
                                                >
                                                    <Typography sx={fontM} mr={1}>Creation Date - {detailsData?.date && dayjs(detailsData?.date).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                                </Box>
                                                <Grid sx={{ width: '100%', height: "80% !important", display: 'flex !important', flexDirection: "column !important", justifyContent: 'center !important', alignItems: 'center !important', }}>
                                                    <Typography sx={{ fontFamily: 'cardiuma-M !important', fontSize: '25px', color: '#6b6767', fontWeight: 'bold', textAlign: "center !important", textTransform: "capitalize" }}>
                                                        User Completed this Step
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }

                                    
                                </Grid>
                            </Box>
                        </Box>
            }
            {
                tabvalue==="2" && <Grid  sx={{height:'500px !important',display:'flex !important', flexDirection:'column !important', overflowY:'scroll !important',overflowX:'hidden !important',
                            "&::-webkit-scrollbar": {
                    width: "5px",
                },
                "&::-webkit-scrollbar-track": {
                    background: "#dddddd"
                },
                "&::-webkit-scrollbar-thumb": {
                    background: "#bbbbbb"
                }
                }}>
                    {/* <Grid  sx={{float:'right !important',display:'flex !important', justifyContent:'end !important', marginRight:'20px !important', }} >   
                        <Select
                            sx={{
                                width:'200px !important', 
                                fontFamily:'cardiuma-Bold !important'
                            }}
                            labelId="demo-simple-select-label"
                            value={year}
                            label="Year"
                            onChange={(e)=>{
                                setIsaa(false)
                                setYear(e.target.value)
                            }}
                        >
                            <MenuItem value={'2023'}>2023</MenuItem>
                            <MenuItem value={'2024'}>2024</MenuItem>
                            <MenuItem value={'2025'}>2025</MenuItem>
                        </Select>
                </Grid> */}
                <Grid 
                sx={{
                    marginTop:'2%',
                     marginRight:'20px !important', 
                    }}
                >          
                <List >

                <ListItem
                sx={listItemStyle}
                secondaryAction={
                        <IconButton edge="end" 
                        disabled={isAccForm}
                        /* Updated preview start dev-trupti on 22-10-2024 */
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("accopening")
                        }}
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()
                            }}>
                        {/* changed icon color by dev-kartik on 02-04-25 */}
                        {isAccForm ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}
                        </IconButton>
                    }
                    >
                    <ListItemText
                    sx={{"fontFamily":'cardiuma-regular !important'}}
                        primary="Account Opening Form"
                        secondary={isAccForm ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem> 

                <ListItem
                sx={listItemStyle}
                secondaryAction={
                    
                <>
                        {/* added by dev-kartik on 02-04-25 */}
                    {!(
                        departmentName === "Franchisee" && agentRole.includes(2)
                    ) && (
                            <IconButton
                                onClick={() => {
                                    handleOpenUploadModal1("aadhaar");
                                }}
                            >
                                <CloudUploadIcon
                                    sx={{
                                        fontSize: "30px",
                                        color: "#42a0f7 !important",
                                    }}
                                />
                            </IconButton>
                        )}

                        <IconButton edge="end" 
                        disabled={isAadhar}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("aadhar")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()
                            }}>
                            {isAadhar ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}   {/* changed icon color by dev-kartik on 02-04-25 */}
                        </IconButton>
                    </> }
                    >
                    <ListItemText
                        primary="Aadhar"
                        secondary={isAadhar ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>

                <ListItem
                sx={listItemStyle}
                    secondaryAction={

                    <>
                     {/* added by dev-kartik on 02-04-25 */}
                    {!(
                        departmentName === "Franchisee" && agentRole.includes(2)
                    ) && (
                            <IconButton
                                onClick={() => {
                                    handleOpenUploadModal1("pan");
                                }}
                            >
                                <CloudUploadIcon
                                    sx={{
                                        fontSize: "30px",
                                        color: "#42a0f7 !important",
                                    }}
                                />
                            </IconButton>
                        )}

                        <IconButton edge="end" 
                        disabled={isPan}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("pan")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()
                            }}>
                                {isPan ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}  {/* changed icon color by dev-kartik on 02-04-25 */}
                        </IconButton>
                        </>
                        }
                    >
                    <ListItemText
                        primary="PAN"
                        secondary={isPan ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>

                <ListItem
                sx={listItemStyle}
                secondaryAction={
                <>
                        {/* added by dev-kartik on 02-04-25 */}
                        {!(
                            departmentName === "Franchisee" && agentRole.includes(2)
                        ) && (
                                <IconButton
                                    onClick={() => {
                                    handleOpenUploadModal1("cancelled_cheque");
                                    }}
                                >
                                    <CloudUploadIcon
                                        sx={{
                                            fontSize: "30px",
                                            color: "#42a0f7 !important",
                                        }}
                                    />
                                </IconButton>
                            )}

                        <IconButton edge="end"  
                        disabled={isCancheque}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("cancelled_cheque")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                            {isCancheque ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />} {/* changed icon color by dev-kartik on 02-04-25 */}
                        </IconButton>
                    </> }
                    >
                    <ListItemText
                        primary="Canceled Cheque"
                        secondary={isCancheque ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>
                <ListItem
                sx={listItemStyle}
                secondaryAction={
                    <>
                        {/* added by dev-kartik on 02-04-25 */}
                        {!(
                            departmentName === "Franchisee" && agentRole.includes(2)
                        ) && (
                                <IconButton
                                    onClick={() => {
                                        handleOpenUploadModal1("selfie");
                                    }}
                                >
                                    <CloudUploadIcon
                                        sx={{
                                            fontSize: "30px",
                                            color: "#42a0f7 !important",
                                        }}
                                    />
                                </IconButton>
                            )}

                        <IconButton edge="end" 
                        disabled={isSelfie}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("selfie")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()
                            }}>
                            {isSelfie ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}  {/* changed icon color by dev-kartik on 02-04-25 */}
                        </IconButton>
                    </>
                    }
                    >
                    <ListItemText
                        primary="Selfie"
                        secondary={isSelfie ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>
                <ListItem
                sx={listItemStyle}
                secondaryAction={

                    <>
                        {/* added by dev-kartik on 02-04-25 */}
                        {!(
                            departmentName === "Franchisee" && agentRole.includes(2)
                        ) && (
                                <IconButton
                                    onClick={() => {
                                        handleOpenUploadModal1("signature");
                                    }}
                                >
                                    <CloudUploadIcon
                                        sx={{
                                            fontSize: "30px",
                                            color: "#42a0f7 !important",
                                        }}
                                    />
                                </IconButton>
                            )}
                        <IconButton edge="end" 
                        disabled={isSign}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("sign")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                            {isSign ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}  {/* changed icon color by dev-kartik on 02-04-25 */}
                        </IconButton>
                    </>
                    }
                    >
                    <ListItemText
                        primary="Signature"
                        secondary={isSign ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>
                <ListItem
                sx={listItemStyle}
                secondaryAction={

                    <>
                        {/* added by dev-kartik on 02-04-25 */}
                        {!(
                            departmentName === "Franchisee" && agentRole.includes(2)
                        ) && (
                                <IconButton
                                    sx={{ marginBottom: "100px !important" }}
                                    onClick={handleOpenAggregatorModal}

                                >
                                    <CloudUploadIcon
                                        sx={{
                                            fontSize: "30px",
                                            color: "#42a0f7 !important",

                                        }}
                                    />
                                </IconButton>
                            )}

                        <IconButton edge="end" 
                        disabled={isAA}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("aa")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                            {isAA ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}   {/* changed icon color by dev-kartik on 02-04-25 */}
                        </IconButton>
                    </>
                    }
                    >
                    <ListItemText
                        primary={<Typography sx={fontM}>Account Aggregator {picDetails?.fno_activation?.password && <Tooltip sx={{ padding: 0 }} title={<Typography fontSize={12}  sx={fontM}>{copyText1}</Typography>}>
                        <IconButton disableRipple style={{padding:'0px', marginLeft:'10px'}} sx={{padding:'0px !important'}} onClick={handleCopyPassword}>
                            <KeyIcon sx={{padding:'0px !important', fontSize:'24px'}}  />
                        </IconButton>
                        </Tooltip>}</Typography>}
                        secondary={isAA ? 'No file found. Try selecting a different year' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>
                {/* <ListItem
                sx={listItemStyle}
                secondaryAction={
                        <IconButton edge="end" 
                        disabled={isPoa}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("poa")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                        {isPoa ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}  
                    }
                    >
                    <ListItemText
                        primary="Power of Attorney"
                        secondary={isPoa ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem> */}
                {/* {
                    selectUser?.citizenship == 1 && <>
                      <ListItem
                sx={listItemStyle}
                secondaryAction={
                        <IconButton edge="end" 
                        disabled={isNri.isPis}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("pis")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                        {isNri.isPis ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />} 
                        </IconButton>
                    }
                    >
                    <ListItemText
                        primary="PIS"
                        secondary={isNri.isPis ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>
                <ListItem
                sx={listItemStyle}
                secondaryAction={
                        <IconButton edge="end" 
                        disabled={isNri.isPan}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("nripan")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                        {isNri.isPan ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}  
                    }
                    >
                    <ListItemText
                        primary="PAN"
                        secondary={isNri.isPan ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>
                <ListItem
                sx={listItemStyle}
                secondaryAction={
                        <IconButton edge="end" 
                        disabled={isNri.isIdentity}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("identity")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                        {isNri.isIdentity ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}  
                        </IconButton>
                    }
                    >
                    <ListItemText
                        primary="Identity"
                        secondary={isNri.isIdentity ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>
                <ListItem
                sx={listItemStyle}
                secondaryAction={
                        <IconButton edge="end" 
                        disabled={isNri.isBankStatement}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("bankstatement")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                        {isNri.isBankStatement ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />}  
                        </IconButton>
                    }
                    >
                    <ListItemText
                        primary="Bank Statement"
                        secondary={isNri.isBankStatement ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>
                <ListItem
                sx={listItemStyle}
                secondaryAction={
                        <IconButton edge="end" 
                        disabled={isNri.isCommunication}
                        onMouseEnter={(e)=>{
                            setPreview(true)
                            handleClick(e)
                            setHover("communication")
                        }}
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseLeave={handleClose}
                        onClick={() => {
                            setDownload(true)
                            handleClose()}}>
                        {isNri.isCommunication ? <FileDownloadOff /> : <Download sx={{ color: "#42a0f7 !important" }} />} 
                        </IconButton>
                    }
                    >
                    <ListItemText
                        primary="Communication Address"
                        secondary={isNri.isCommunication ? 'No file found' : null}
                        primaryTypographyProps={fontM}
                        secondaryTypographyProps={fontR}
                    />
                </ListItem>

                    </>
                } */}

                </List>
                </Grid>
                <Popover
                    id="mouse-over-popover"
                    sx={{ pointerEvents: "none" }}
                    open={open}
                    disableRestoreFocus
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    >
        
                    <Box sx={{padding:'10px !important'}}>
                        {loader===true?   <CircularProgress siz={100} />: (previewimg !=="" ? <img  src={previewimg} height={200} width={250} style={{border:'1px solid #d6d4d4',borderRadius:'5px'}}/>: null)}
                        <Typography sx={{fontFamily:'cardiuma-SemiBold !important' , textAlign:'center !important'}}>{previewtext}</Typography>
                    </Box>
            </Popover>
                </Grid>
                                        /* Updated preview end dev-trupti on 22-10-2024 */
            }
            {
                tabvalue === '3' && <>
                            <Box sx={{
                                margin: docVerification.length !== 0? '20px 0px 0px 130px !important':'20px 0px 0px 0px !important',display: 'flex !important', height:'479px !important', overflowY:'auto !important', border:'0.5px solid #eeeeee', borderRadius:'15px !important',
                     '&::-webkit-scrollbar': {
                        width: '5px',
                      },

                      '&::-webkit-scrollbar-thumb': {
                        width: '5px',
                        background: '#bbbbbb'
                      },
                      '&::-webkit-scrollbar-track': {
                        background:'#dddddd'
                      }
                 }}>                        
                                {docVerification.length !== 0 ?<><Drawer
                            sx={{
                            width: '90px',
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                border:'0.5px solid #eeeeee',
                                //dev-trupti on 31-10-2024
                                borderRadius:'15px !important',
                                boxSizing: 'border-box',
                                marginTop:'100px !important',
                                marginLeft:'30px !important',
                                height:'482px !important',
                                width:'250px !important'
                            },
                            '& .css-12i7wg6-MuiPaper-root-MuiDrawer-paper':{
                                overflowX:'auto !important',
                                '&::-webkit-scrollbar': {
                                    width: '5px',
                                    height: '8px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    width: '5px',
                                    background: '#bbbbbb'
                                },
                                '&::-webkit-scrollbar-track': {
                                    background:'#dddddd'
                                }
                            }
                            }}
                            variant="permanent"
                            anchor="left"
                        >
                            <List>
                             {/* eslint-disable-next-line */}
                             
                                        {docVerification?.map((ele, index) => (
                                            <ListItem key={index} disablePadding>
                                                {/* Added highlighting api response start dev-trupti on 22-10-2024  */}
                                                <ListItemButton
                                    sx={{backgroundColor: selectedIndex1===index && '#f2d0d0 !important'}}
                                    selected={selectedIndex1 === index}
                                                 
                                                  
                                    onClick={()=>{ 
                                                        setSelectedIndex1(index)
                                                        setViewdata(ele)                                             
                                                        //dev-trupti on 31-10-2024
                                                    }}
                                                >
                                                    {/* Added highlighting api response end dev-trupti on 22-10-2024 */}
                                                    {/* added condition dev-kartik on 02-04-25 */}
                                                    <ListItemText primary={formatVerification(ele === "fno_activation" ? "F&O Document" : ele)}
                                                        primaryTypographyProps={fontM}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                            </List>
                        </Drawer>
                        <Box sx={{ bgcolor: 'background.default' ,margin:'10px 10px 0px 50px !important', width:'950px',wordBreak:'break-word', justifyContent:'right !important'}}>
                {viewdata === 'aadhaar' && <>
                                <Grid 
                                    sx={{height:'300px', overflowY:'scroll',  "&::-webkit-scrollbar": {
                                        width: "5px",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                        background: "#dddddd"
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                        background: "#bbbbbb"
                                    },border:'1px solid #eeeeee', borderRadius:'15px !important'}}>   
                                    <img src={picDetails.aadhaar?.data} width='100%' ></img>
                                </Grid>
                                            {
                                                aadhaarAddress ? <Grid
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        marginTop: '10px !important'
                                                    }}
                                                >

                                                    <Typography sx={{ fontFamily: "cardiuma-M" }}>
                                                        <Box component="span" sx={{ fontWeight: "bold" }}>
                                                            Copy Address from here :
                                                        </Box>{" "}
                                                        {aadhaarAddress}
                                                    </Typography>


                                                    {/* Buttons on the Right */}
                                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                                        {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                                        {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (
                                                            <Button
                                                                variant="contained"
                                                                sx={disableOcr ? buttondisabled : buttons}
                                                                onClick={() => fetchOcrDetails('aadhaar')}
                                                                disabled={disableOcr}
                                                            >
                                                                FETCH DETAILS
                                                            </Button>
                                                        )}
                                                        {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (
                                                            <Button
                                                                variant="contained"
                                                                sx={buttons}
                                                                onClick={() => verificationDownload('aadhar')}
                                                            >
                                                                DOWNLOAD IMAGE
                                                            </Button>
                                                        )}
                                                    </Box>
                                                </Grid> 
                                                :
                                                <Grid sx={{ display: 'flex !important', justifyContent: 'end !important', marginTop: '10px !important' }}>

                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={disableOcr ? buttondisabled : buttons} onClick={() => { fetchOcrDetails('aadhaar') }} disabled={disableOcr}>FETCH DETAILS </Button>)}
                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={() => { verificationDownload('aadhar') }}>DOWNLOAD IMAGE</Button>)}
                                                </Grid>
                                             }

                                            

                                            <Grid>
                                                <Grid sx={{ display: 'flex !important', flexDirection: 'column !important', marginTop: '15px !important', }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                                                        <Box sx={{ display: 'flex', width: '100%', gap: 3 }}>
                                                            <TextField label="Aadhaar number*" name="aadhaar_number" size="small" variant="outlined" fullWidth value={aadhaarData.aadhaar_number} onChange={handleAadhaarChange} error={!!aadhaarErrors.aadhaar_number} helperText={aadhaarErrors.aadhaar_number} />
                                                            <TextField label="Full Name*" name="fullName" size="small" variant="outlined" fullWidth value={aadhaarData.fullName} onChange={handleAadhaarChange} error={!!aadhaarErrors.fullName} helperText={aadhaarErrors.fullName} />
                                                        </Box>
                                                        
                                                        <TextField label="Address1 (House/Landmark)*" name="address1" size="small" variant="outlined" fullWidth value={aadhaarData.address1} onChange={handleAadhaarChange} error={!!aadhaarErrors.address1} helperText={aadhaarErrors.address1} />
                                                        <TextField label="Address2 (Location/Area)*" name="address2" size="small" variant="outlined" fullWidth value={aadhaarData.address2} onChange={handleAadhaarChange} error={!!aadhaarErrors.address2} helperText={aadhaarErrors.address2} />
                                                        <Box sx={{ display: 'flex', width: '100%', gap: 3 }}>
                                                            <TextField label="Pincode*" name="pincode" size="small" variant="outlined" fullWidth value={aadhaarData.pincode} onChange={handleAadhaarChange} error={!!aadhaarErrors.pincode} helperText={aadhaarErrors.pincode} />
                                                            <TextField label="District*" name="district" size="small" variant="outlined" fullWidth value={aadhaarData.district} onChange={handleAadhaarChange} error={!!aadhaarErrors.district} helperText={aadhaarErrors.district} />
                                                        </Box>
                                                        <Box sx={{ display: 'flex', width: '100%', gap: 3 }}>
                                                            {/* <TextField label="State*" name="state" size="small" variant="outlined" fullWidth value={aadhaarData.state} onChange={handleAadhaarChange} error={!!aadhaarErrors.state} helperText={aadhaarErrors.state} /> */}
                                                            <FormControl
                                                                fullWidth
                                                                size="small"
                                                                error={Boolean(aadhaarErrors.state)}
                                                            >
                                                                <Select
                                                                    name="state"
                                                                    value={aadhaarData.state || ""}
                                                                    onChange={handleAadhaarChange}
                                                                    input={<OutlinedInput />}
                                                                    displayEmpty
                                                                    renderValue={(selected) => {
                                                                        if (!selected) {
                                                                            return <span style={{ color: "#888" }}>State</span>;
                                                                        }

                                                                        return (
                                                                            stateOptions.find((x) => x.CODE === selected)?.Description ||
                                                                            selected
                                                                        );
                                                                    }}
                                                                >
                                                                    <MenuItem disabled value="">
                                                                        State
                                                                    </MenuItem>

                                                                    {stateOptions.map((state) => (
                                                                        <MenuItem key={state.CODE} value={state.CODE}>
                                                                            {state.Description}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>

                                                                <FormHelperText error>
                                                                    {aadhaarErrors.state}
                                                                </FormHelperText>
                                                            </FormControl>
                                                            <TextField label="City*" name="city" size="small" variant="outlined" fullWidth value={aadhaarData.city} onChange={handleAadhaarChange} error={!!aadhaarErrors.city} helperText={aadhaarErrors.city} />
                                                        </Box>
                                                       
                                                       
                                                    </div>
                                                </Grid>
                                                <Grid mt={3} sx={{ float: 'right', }}>
                                                    {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={() => { uploadDoc('aadhaar') }}>UPLOAD </Button>)}
                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={!picDetails.aadhaar?.data ? buttondisabled : buttons}
                                                        disabled={!picDetails.aadhaar?.data}
                                                        onClick={() => {
                                                            if (validateAadhaarData()) {
                                                                const original = aadhaarData.aadhaar_number.replace(/\D/g, ''); // remove non-digits
                                                                const last4 = original.slice(-4);

                                                                setAadhaarData(prev => ({
                                                                    ...prev,
                                                                    aadhaar_number: `XXXXXXXX${last4}`
                                                                }));

                                                                confirmDialog('aadhaar');
                                                            }
                                                        }}
                                                    >APPROVE </Button>)}
                                                </Grid>
                                            </Grid>

                        </>}
                        {viewdata === 'pan' && <>
                                <Grid 
                                    sx={{height:'300px', overflowY:'scroll',  "&::-webkit-scrollbar": {
                                        width: "5px",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                        background: "#dddddd"
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                        background: "#bbbbbb"
                                    },border:'1px solid #eeeeee', borderRadius:'15px !important'}}>   
                                                <img src={picDetails.pan?.data} width='100%' ></img>
                                </Grid>
                                <Grid  sx={{display:'flex !important', justifyContent:'end !important', marginTop:'10px !important'  }}>
                                {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={()=>{verificationDownload('pan')}}>DOWNLOAD IMAGE </Button>)}
                                </Grid>
                                <Grid>
                                    <Grid>
                                    <Typography>Registered Pan name - {perData.name}</Typography> 
                                                    <Typography>Registered Pan number - {perData.pan_no}</Typography> 
                                    </Grid>
                                    <Grid mt={3} sx={{float:'right', }}>
                                        {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                        {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={()=>{uploadDoc('pan')}}>UPLOAD </Button>)}
                                        {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" 
                                        sx={!picDetails.pan?.data ? buttondisabled : buttons}
                                        disabled={!picDetails.pan?.data} 
                                        onClick={()=>{confirmDialog('pan')}}>APPROVE </Button>)}
                                    </Grid>
                                </Grid>
                                
                            </>}
                         {viewdata === 'cancelled_cheque' && <>
                                <Grid 
                                    sx={{height:'200px', overflowY:'scroll',  "&::-webkit-scrollbar": {
                                        width: "5px",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                        background: "#dddddd"
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                        background: "#bbbbbb"
                                    },border:'1px solid #eeeeee', borderRadius:'15px !important'}}>   
                                                <img src={picDetails.cancelled_cheque.data} width='100%' ></img>
                                </Grid>
                            <Grid sx={{width:'100% !important',display:'flex !important', justifyContent:'center !important', marginTop:'10px !important' }}>
                                <Grid container sx={{width:'800px !important'}}>
                                    <Grid xl={7} lg={8} md={7} sm={9} xs={9} sx={{display:'flex !important', alignItems:'center !important'}}> 

                                    <FormControl sx={{display:'flex !important', flexDirection:'row !important',  alignItems:'center !important'}}>
                                        <Typography 
                                        sx={{margin:'0px 130px 0px 20px !important',
                                            display:'flex !important',
                                            alignItems:'center !important'
                                            }}
                                        >Bank Type</Typography>
                                        <RadioGroup
                                        row
                                            value={bankType}
                                            name="radio-buttons-group"
                                            onChange={handleBankChange} 
                                        >
                                            <FormControlLabel value="Savings" sx={{marginRight:'30px !important'}} control={<Radio />} label="Savings" />
                                            <FormControlLabel value="Current" control={<Radio />} label="Current" />
                                        </RadioGroup>
                                    </FormControl>

                                    </Grid>
                                    <Grid>
                                        {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                                        {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button sx={downloadButton} onClick={() => {
                                                            
                                                            verificationDownload("cancelled_cheque")}}>
                                            DOWNLOAD IMAGE
                                        </Button>)}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid xl={4} lg={4} md={4} sm={6} xs={6}  mt={3} sx={{display :'flex', flexDirection:'column', alignItems:'end !important' }} >
                                    <Typography  mb={2} sx={fontM}>Account No:</Typography>
                                    <Typography mb={2} sx={fontM}>IFSC:</Typography>
                                    <Typography sx={fontM}>Account Holder Name:</Typography>
                                </Grid>
                                <Grid xl={8} lg={8} md={8} sm={6} xs={6} pl={2} >
                                    <TextField 
                                        label={<Typography sx={fontM}>Account Number</Typography>}
                                        value={acc}
                                        size='small'
                                        type="text"
                                        style={{ alignContent: 'center', justifyContent: 'center' }}
                                        inputProps={{
                                            style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width:'400px' }
                                        }}
                                        onChange={(e)=>{setAcc(e.target.value)}}
                                    />
                                    <TextField 
                                        label={<Typography sx={fontM}>IFSC</Typography>}
                                        value={ifsc}
                                        size='small'
                                        type="text"
                                        style={{ alignContent: 'center', justifyContent: 'center' }}
                                        inputProps={{
                                            style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width:'400px'  }
                                        }}
                                        onChange={(e)=>{setIfsc(e.target.value)}}
                                    />
                                    <TextField 
                                        // disabled
                                        label={<Typography sx={fontM}>Name</Typography>}
                                        value={bankHolderName}
                                        size='small'
                                        type="text"
                                        style={{ alignContent: 'center', justifyContent: 'center' }}
                                        inputProps={{
                                            style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width:'400px' }
                                        }}
                                          onChange={(e) => {setBankHolderName(e.target.value) }}       
                                    />
                                </Grid>
                            </Grid>
                            <Grid mt={3} sx={{float:'right', marginRight:'4% !important'}}>
                                {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                                {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={() => { uploadDoc('cancelled_cheque')}}>
                                    UPLOAD
                                </Button>)}
                                {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={()=>{validateBank()}}>
                                    VALIDATE
                                </Button>)}
                                {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" mr={2}
                                                    disabled={!picDetails.cancelled_cheque.data || (picDetails.cancelled_cheque.data && isName === true)}

                                   sx={
                                       !picDetails.cancelled_cheque.data
                                       ? buttondisabled 
                                       : (isName === false) 
                                         ? buttons 
                                         : buttondisabled
                                   }
                                onClick={() => { confirmDialog('cancelled_cheque')}}
                                >
                                    APPROVE
                                </Button>)}
                            </Grid></>}
                            
                                        {viewdata === 'selfie' && <>
                                            <Grid
                                                sx={{
                                                    height: '300px', overflowY: 'scroll', "&::-webkit-scrollbar": {
                                                        width: "5px",
                                                    },
                                                    "&::-webkit-scrollbar-track": {
                                                        background: "#dddddd"
                                                    },
                                                    "&::-webkit-scrollbar-thumb": {
                                                        background: "#bbbbbb"
                                                    }, border: '1px solid #eeeeee', borderRadius: '15px !important'
                                                }}>
                                                <img src={picDetails.selfie?.data} width='100%' ></img>
                                            </Grid>
                                            <Grid sx={{ display: 'flex !important', justifyContent: 'end !important', marginTop: '10px !important' }}>
                                                {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                               
                                                {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={() => {verificationDownload('selfie') }}>DOWNLOAD IMAGE</Button>)}
                                            </Grid>
                                            <Grid>
                                                <Grid mt={3} sx={{ float: 'right', }}>
                                                    {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={() => { uploadDoc('selfie') }}>UPLOAD </Button>)}
                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={!picDetails.selfie?.data ? buttondisabled : buttons}
                                                        disabled={!picDetails.selfie?.data}
                                                        onClick={() => { confirmDialog('selfie') }}
                                                    >APPROVE </Button>)}
                                                </Grid>
                                            </Grid>

                                        </>}
                                        {viewdata === 'signature' && <>
                                            <Grid
                                                sx={{
                                                    height: '300px', overflowY: 'scroll', "&::-webkit-scrollbar": {
                                                        width: "5px",
                                                    },
                                                    "&::-webkit-scrollbar-track": {
                                                        background: "#dddddd"
                                                    },
                                                    "&::-webkit-scrollbar-thumb": {
                                                        background: "#bbbbbb"
                                                    }, border: '1px solid #eeeeee', borderRadius: '15px !important'
                                                }}>
                                                <img src={picDetails.signature?.data} width='100%' ></img>
                                            </Grid>
                                            <Grid sx={{ display: 'flex !important', justifyContent: 'end !important', marginTop: '10px !important' }}>
                                                {/* Disable for Franchise Dept - srini - 05-03-25 */}

                                                {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={() => { verificationDownload('signature') }}>DOWNLOAD IMAGE</Button>)}
                                            </Grid>
                                            <Grid>
                                                <Grid mt={3} sx={{ float: 'right', }}>
                                                    {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={() => { uploadDoc('signature') }}>UPLOAD </Button>)}
                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={!picDetails.selfie?.data ? buttondisabled : buttons}
                                                        disabled={!picDetails.selfie?.data}
                                                        onClick={() => { confirmDialog('signature') }}
                                                    >APPROVE </Button>)}
                                                </Grid>
                                            </Grid>

                                        </>}
                        {viewdata === 'fno_activation' && <>
                                <Grid 
                                    sx={{height:'300px', border:'1px solid #eeeeee', borderRadius:'15px !important', display:'flex !important', flexDirection:'column !important', justifyContent:'center !important', alignItems:'center !important'}}>   
                                        {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                                {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={{ ...buttons, height: '40px' }} onClick={() => { verificationDownload('fno_activation')}}>DOWNLOAD PDF </Button>)}
                                        {/* {selectUser?.bankstmtpwd != null && <Typography sx={{marginTop:'15px !important',fontSize:'14px !important'}}>Password: {selectUser?.bankstmtpwd}</Typography>} */}
                                                {picDetails.fno_activation?.password && <Box mt={1}>
                                            <Tooltip sx={{ padding: 0 }} title={<Typography fontSize={12}  sx={fontM}>{copyText1}</Typography>}>
                        <IconButton disableRipple style={{padding:'0px', marginLeft:'10px'}} sx={{padding:'0px !important'}} onClick={handleCopyPassword}>
                            <KeyIcon sx={{padding:'0px !important', fontSize:'24px'}}  />
                        </IconButton>
                        </Tooltip></Box>}

                                </Grid>
                                <Grid mt={3}>
                                    <Grid>
                                     <Typography>Registered Bank Name - {perData?.account_name}</Typography> 
                                                    <Typography>Registered Bank IFSC number - {perData?.ifsc_code }</Typography> 
                                                    <Typography>Registered Bank Account number - {perData?.account_number }</Typography>
                                                    <Typography>Document Type - {picDetails?.fno_activation?.type}</Typography>    {/* added by dev-kartik on 02-04-25 */}
                                    </Grid>
                                    <Grid  sx={{float:'right', }}>
                                        {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                                    {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" sx={buttons} onClick={() => { uploadDoc('fno_activation')}} >UPLOAD </Button>)}
                                        {!(departmentName === 'Franchisee' && agentRole.includes(2)) && (<Button variant="contained" 
                                            sx={!picDetails?.fno_activation?.data ? buttondisabled : buttons}
                                                        disabled={!picDetails?.fno_activation?.data}
                                                        onClick={() => {
                                                            confirmDialog('fno_activation')}}>APPROVE </Button>)}
                                    </Grid>
                                </Grid>
                            </>}
                        </Box></>: <Grid sx={{width:'100%', display:'flex !important',flexDirection:"column !important", justifyContent:'center !important',alignItems:'center !important', }}><Typography sx={{fontFamily:'cardiuma-M !important',  fontSize:'25px', color:'#6b6767', fontWeight:'bold'}}>
                            No Verifications Pending
                            </Typography>
                                        {/* <Box sx={{ marginTop: "100px !important" }}>
                                            <Pagination count={10} variant="outlined" color="secondary" />
                            </Box> */}
                              
                            </Grid>}
                    </Box>
                </>
            }
            {
              tabvalue === "4"  && <>
                <Box sx={{ margin:'20px 0px 0px 130px !important',display: 'flex !important', height:'479px !important', overflowY:'auto !important', border:'0.5px solid #eeeeee', borderRadius:'15px !important',
                     '&::-webkit-scrollbar': {
                        width: '5px',
                      },

                      '&::-webkit-scrollbar-thumb': {
                        width: '5px',
                        background: '#bbbbbb'
                      },
                      '&::-webkit-scrollbar-track': {
                        background:'#dddddd'
                      }
                 }}>                        
                        <Drawer
                            sx={{
                            width: '90px',
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                border:'0.5px solid #eeeeee',
                                //dev-trupti on 31-10-2024
                                borderRadius:'15px !important',
                                boxSizing: 'border-box',
                                marginTop:'100px !important',
                                marginLeft:'30px !important',
                                height:'482px !important',
                                width:'250px !important'
                            },
                            '& .css-12i7wg6-MuiPaper-root-MuiDrawer-paper':{
                                overflowX:'auto !important',
                                '&::-webkit-scrollbar': {
                                    width: '5px',
                                    height: '8px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    width: '5px',
                                    background: '#bbbbbb'
                                },
                                '&::-webkit-scrollbar-track': {
                                    background:'#dddddd'
                                }
                            }
                            }}
                            variant="permanent"
                            anchor="left"
                        >
                            <List>
                             {/* eslint-disable-next-line */}
                            {regData?.map((ele, index) => (
                                <ListItem key={index} disablePadding>
                                 {/* Added highlighting api response start dev-trupti on 22-10-2024  */}
                                <ListItemButton 
                                    sx={{backgroundColor: selectedIndex===index && '#f2d0d0 !important'}}
                                    selected={selectedIndex===index}
                                    onClick={()=>{
                                        setSelectedIndex(index)
                                        setCreatedOn(ele.createdAt)
                                        setData(JSON.stringify(ele.data));
                                        setVerification(ele.verification)
                                        //dev-trupti on 31-10-2024
                                        setCopyText('Copy Response')
                                        }}
                                    >
                                    {/* Added highlighting api response end dev-trupti on 22-10-2024 */}
                                    <ListItemText primary={formatVerification(ele.verification)}
                                     primaryTypographyProps={fontM}
                                    />
                                </ListItemButton>
                                </ListItem>
                            ))}
                            </List>
                        </Drawer>
                        <Box 
                            sx={{ bgcolor: 'background.default' ,margin:'10px 10px 0px 50px !important', width:'950px',wordBreak:'break-word'}}
                        >
                            {/* dev-trupti on 22-10-2024 */}
                            <Grid mt={2} mb={2} sx={{display:'flex', flexDirection:'row', justifyContent:'end', alignItems:'center'}}>
                            <Typography sx={fontM} mr={1}>Creation Date - {createdOn && dayjs(createdOn).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                            <Tooltip title={<Typography fontSize={12} sx={fontM}>{copyText}</Typography>}>
                            <IconButton onClick={handleCopy}>
                                <ContentCopyIcon />
                            </IconButton>
                            </Tooltip>
                            </Grid>
                            <Typography sx={fontM} >JSON Response - </Typography>
                            <Grid mt={1} sx={{wordBreak:'break-word'}}>
                            <Typography  sx={fontR} mt={2} >{data}</Typography>
                            </Grid>
                        </Box>
                        </Box>
                </>
            }
            {/* Added subscription tab on 31-10-2024 */}
            {
                tabvalue==="5" && <>
                <Box sx={{ margin:'20px 0px 0px 0px !important',display: 'flex !important', height:'479px !important', border:'0.5px solid #eeeeee', borderRadius:'15px !important',overflow: 'hidden !important',
                 }}>                        
                             {rows.length !==0 ? <TableContainer 
                            //  sx={{overflow: 'hidden !important'}} 
                            className="custom-scrollbar"
                             component={Paper}>
                                <Table >
                                    <TableHead>
                                        <TableRow sx={{ height: '20px !important' }}>
                                            <TableCell width='25%' sx={tableHeadStyle}>PRODUCT</TableCell>
                                            <TableCell width='15%' sx={tableHeadStyle}>PLAN</TableCell>
                                            <TableCell width= '10%' sx={tableHeadStyle}>STATUS</TableCell>
                                            <TableCell width='20%'sx={tableHeadStyle}>PLAN END DATE</TableCell>
                                            <TableCell width='15%' sx={tableHeadStyle}>EXPIRES</TableCell>
                                            <TableCell width='20%' sx={{textAlign: 'center', ...tableHeadStyle}}>AMOUNT</TableCell>
                                            <TableCell width='5%'sx={tableHeadStyle}> </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <>
                                                <TableRow key={row.id}>
                                                    <TableCell><Box
                                                            sx={{
                                                                backgroundColor: row.id === 'Wealth Vault' ? '#fff6e4' : '#e9f4ff', // Lighter background
                                                                border: `2px solid ${row.id === 'Wealth Vault' ? '#9a8650' : '#6193c3'}`, // Border color matches text
                                                                color: row.id === 'Wealth Vault' ? '#9a8650' : '#6193c3', // Text color
                                                                borderRadius: '14px',
                                                                padding: '4px 8px',
                                                                display: 'inline-block',
                                                                }}
                                                                                        >
                                                                <Typography sx={tableBodyStyle} variant="body2">
                                                                    {row.id}
                                                                </Typography>
                                                        </Box></TableCell>
                                                    <TableCell sx={tableBodyStyle}>
                                                        {row.plan_Type}
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {row.plan_Status ? (
                                                            <CheckIcon style={{ color: 'green' }} />
                                                        ) : (
                                                            <CloseIcon style={{ color: 'red' }} />
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={tableBodyStyle}>{row.plan_end_date}</TableCell>
                                                    <TableCell sx={tableBodyStyle}>{row.plan_expires}</TableCell>
                                                    <TableCell sx={tableBodyStyle} align="center">{row.plan_amount}</TableCell>
                                                    <TableCell>
                                                        {row.id === "Wealth Vault" && (
                                                            <IconButton
                                                                aria-label="expand row"
                                                                size="small"
                                                                onClick={() => handleCollapsable(row.id)}
                                                            >
                                                                {opencol=== row.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                                {/* { opencol=== row.id && ( */} 
                                                {/* className="custom-scrollbar" 
                                                                     sx={{ overflowY:'auto !important'}} */}
                                                    <TableRow>
                                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7} sx={{paddingTop:'0px !important'}}>
                                                            <Collapse in={opencol  === row.id} timeout="auto" unmountOnExit>
                                                                <Box sx={{height: 'auto !important', overflowY: 'auto !important'}}>
                                                                    { paymentHistory?.length !==0 ?  <TableContainer >
                                                                    <Table  size="small" aria-label="purchases">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell sx={tableHeadStyle}>TYPE</TableCell>
                                                                                <TableCell sx={{textAlign:'center !important',...tableHeadStyle}}>AMOUNT</TableCell>
                                                                                <TableCell sx={tableHeadStyle}>ORDER ID</TableCell>
                                                                                <TableCell sx={tableHeadStyle}>JV ENTRY</TableCell>
                                                                                <TableCell sx={tableHeadStyle}>CREATED AT</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {
                                                                                paymentHistory?.map((ele)=>(
                                                                                    <TableRow key={ele.order_id}>
                                                                                        <TableCell>  <Box
                                                                                            sx={{
                                                                                                backgroundColor: ele.subscription_type === 'Energetic' ? '#ffcccc' : '#E6F7EF', // Lighter background
                                                                                                border: `2px solid ${ele.subscription_type === 'Energetic' ? '#fe4141' : '#33c472'}`, // Border color matches text
                                                                                                color: ele.subscription_type === 'Energetic' ? '#fe4141' : '#33c472', // Text color
                                                                                                borderRadius: '14px',
                                                                                                padding: '4px 8px',
                                                                                                display: 'inline-block',
                                                                                            }}
                                                                                        >
                                                                                            <Typography sx={tableBodyStyle} variant="body2">
                                                                                                {ele.subscription_type}
                                                                                            </Typography>
                                                                                        </Box></TableCell>
                                                                                        <TableCell sx={{textAlign:'center !important',...tableBodyStyle}}>{ele.amount}</TableCell>
                                                                                        <TableCell sx={tableBodyStyle}>{ele.order_id}</TableCell>
                                                                                        <TableCell sx={tableBodyStyle}>{ele.jv_no}</TableCell>
                                                                                        <TableCell sx={tableBodyStyle}>{new Date(ele.createdAt).toLocaleString()}</TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                            }
                                                                        </TableBody>
                                                                    </Table>
                                                                    </TableContainer> :<Typography textAlign="center" sx={tableSubHeadStyle}>No Records Found</Typography> }
                                                                </Box>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow>
                                                {/* )} */}
                                            </>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer> :<Typography pt={25} sx={{fontFamily:'cardiuma-M !important',marginLeft:'38% !important', fontSize:'25px', color:'#6b6767', fontWeight:'bold'}}>
                        No Records Found
                        </Typography>}
                        </Box>
                </>
            }

            {
                tabvalue ==="6" && <>
                            <Box sx={{
                                margin: '20px 0px 0px 130px !important', display: 'flex !important', height: '479px !important', overflowY: 'auto !important', border: '0.5px solid #eeeeee', borderRadius: '15px !important',
                                '&::-webkit-scrollbar': {
                                    width: '5px',
                                },

                                '&::-webkit-scrollbar-thumb': {
                                    width: '5px',
                                    background: '#bbbbbb'
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: '#dddddd'
                                }
                            }}>
                                <Drawer
                                    sx={{
                                        width: '90px',
                                        flexShrink: 0,
                                        '& .MuiDrawer-paper': {
                                            border: '0.5px solid #eeeeee',
                                            //dev-trupti on 31-10-2024
                                            borderRadius: '15px !important',
                                            boxSizing: 'border-box',
                                            marginTop: '100px !important',
                                            marginLeft: '30px !important',
                                            height: '482px !important',
                                            width: '250px !important'
                                        },
                                        '& .css-12i7wg6-MuiPaper-root-MuiDrawer-paper': {
                                            overflowX: 'auto !important',
                                            '&::-webkit-scrollbar': {
                                                width: '5px',
                                                height: '8px',
                                            },
                                            '&::-webkit-scrollbar-thumb': {
                                                width: '5px',
                                                background: '#bbbbbb'
                                            },
                                            '&::-webkit-scrollbar-track': {
                                                background: '#dddddd'
                                            }
                                        }
                                    }}
                                    variant="permanent"
                                    anchor="left"
                                >
                                    <List>

                                        {onboardDetials?.map((ele, index) => (
                                            <ListItem key={index} disablePadding>

                                                <ListItemButton
                                                    sx={{ backgroundColor: onBoardIndex === index && '#f2d0d0 !important' }}
                                                    selected={onBoardIndex === index}
                                                    onClick={() => {
                                                      

                                                        // if (ele.type === "NomineeDetails") {
                                                        //     const aadhaar = decodeBase64(ele?.nominee_aadhaar)
                                                        //     ele.nominee_decoded_aadhaar = aadhaar.slice(-5, -1)
                                                        // }

                                                     
                                                        setOnBoardIndex(index)
                                                        // // setCreatedOn(ele.createdAt)
                                                        setOnBoardData(ele);
                                                        // setVerification(ele)
                                                        //dev-trupti on 31-10-2024
                                                    
                                                    }}
                                                >


                                                    <ListItemText
                                                        primary={formatVerification(ele)}
                                                        primaryTypographyProps={fontM}
                                                    />

                                                    {/* {ele.status && ( // Conditionally render the icon based on ele.status
                                                        <ListItemIcon>
                                                            <img src={verified} alt="icon" />
                                                        </ListItemIcon>
                                                    )} */}


                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Drawer>
                                <Box
                                    sx={{ bgcolor: 'background.default', margin: '10px 10px 0px 50px !important', width: '950px', display: 'flex', flexDirection: 'row', justifyContent: 'center', textAlign: 'center', wordBreak: 'break-word' }}
                                >

                                    <Grid mt={2} mb={2} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center' }}>
                                        {/* <Typography sx={fontM} mr={1}>Creation Date - {createdOn && dayjs(createdOn).format('DD/MM/YYYY hh:mm:ss')}</Typography> */}
                                        {/* <Tooltip title={<Typography fontSize={12} sx={fontM}>{copyText1}</Typography>}>
                                        <IconButton onClick={handleCopy}>
                                            <ContentCopyIcon />
                                        </IconButton>
                                    </Tooltip> */}
                                    </Grid>
                                    {/* <Typography sx={fontM} >  </Typography> */}
                                    <Grid mt={1} >

                                        { 
                                            onBoardData =="UserDetails" && <>
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.user || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }
                                      
                                     
                                       



                                        {
                                            onBoardData == "ResidentialAddress" && <>
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.address?.residential || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            onBoardData == "RegisteredAddress" && <>
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.address?.registered || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            onBoardData == "BankDetails" && <>
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.bank_info || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            onBoardData == "ContactDetails" && <>
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center",minHeight:"400px" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.contact_info || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }


                                        {
                                            onBoardData == "Documents" && <>
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.files || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            onBoardData == "IncomeDetails" && <>
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.income_info || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }

                                        {
                                            onBoardData === "NomineeDetails" && (
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.nominee_info || {}).map(([key, value]) => {
                                                                let displayValue = value;

                                                                if (key === "nominee_aadhar") {
                                                                    const decoded = decodeBase64(value);
                                                                    displayValue = decoded && decoded.length >= 4
                                                                        ? decoded.slice(-5,-1)
                                                                        : "-";
                                                                }

                                                                return (
                                                                    <TableRow key={key}>
                                                                        <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                        <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{displayValue || "-"}</TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            )
                                        }







                                        {
                                            onBoardData == "Segments" && <>
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.others || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }



                                        {
                                            onBoardData === "PersonalDetatils" && (
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.personal_info || {}).map(([key, value]) => {
                                                                let displayValue = value;

                                                                if (key === "aadharcard" || key === "pan_no") {
                                                                    const decoded = decodeBase64(value);

                                                                    if (key === "aadharcard") {
                                                                        displayValue = decoded && decoded.length >= 4
                                                                            ? decoded.slice(-5,-1)
                                                                            : "-";
                                                                    } else if (key === "pan_no") {
                                                                        displayValue = decoded.slice(1, -1)  || "-";
                                                                    }
                                                                }

                                                                // pan_no is shown fully, so no masking
                                                                return (
                                                                    <TableRow key={key}>
                                                                        <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                        <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{displayValue || "-"}</TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            )
                                        }




                                        {
                                            onBoardData == "OtherDetails" && <> 
                                                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                                                    <Table sx={{ border: "1px solid #ccc", borderCollapse: "collapse" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Field</TableCell>
                                                                <TableCell sx={{ ...fontB, border: "1px solid #ccc" }}>Value</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.entries(kycOnBoardData?.static_constants || {}).map(([key, value]) => (
                                                                <TableRow key={key}>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{key}</TableCell>
                                                                    <TableCell sx={{ ...fontM, border: "1px solid #ccc" }}>{value || "-"}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </>
                                        }

                                    </Grid>
                                </Box>
                            </Box>
                </>
            }

            {
                tabvalue === "7" && <>
                    <Box sx={{
                        width: '100%', margin: '20px 0px 0px 0px !important', display: 'flex !important', height: '479px !important', border: '0.5px solid #eeeeee', borderRadius: '15px !important', overflow: 'hidden !important', flexDirection: 'column !important'
                    }}>
                                <Fno_Activation fno={fno} />
                    </Box>
                </>
            }

            {
                tabvalue === "8" && <>
                    <Box sx={{
                        margin: '20px 0px 0px 130px !important', display: 'flex !important', height: '479px !important', overflowY: 'auto !important', border: '0.5px solid #eeeeee', borderRadius: '15px !important',
                        '&::-webkit-scrollbar': {
                            width: '5px',
                        },

                        '&::-webkit-scrollbar-thumb': {
                            width: '5px',
                            background: '#bbbbbb'
                        },
                        '&::-webkit-scrollbar-track': {
                            background: '#dddddd'
                        }
                    }}>
                        <Drawer
                            sx={{
                                width: '90px',
                                flexShrink: 0,
                                '& .MuiDrawer-paper': {
                                    border: '0.5px solid #eeeeee',
                                    //dev-trupti on 31-10-2024
                                    borderRadius: '15px !important',
                                    boxSizing: 'border-box',
                                    marginTop: '100px !important',
                                    marginLeft: '30px !important',
                                    height: '482px !important',
                                    width: '250px !important'
                                },
                                '& .css-12i7wg6-MuiPaper-root-MuiDrawer-paper': {
                                    overflowX: 'auto !important',
                                    '&::-webkit-scrollbar': {
                                        width: '5px',
                                        height: '8px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        width: '5px',
                                        background: '#bbbbbb'
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#dddddd'
                                    }
                                }
                            }}
                            variant="permanent"
                            anchor="left"
                        >
                            <List>
                                
                                {resendArr?.map((ele, index) => (
                                    <ListItem key={index} disablePadding>
                                        <ListItemButton
                                            sx={{ backgroundColor: selectedIndex2 === index && '#f2d0d0 !important' }}
                                            selected={selectedIndex2 === index}
                                            onClick={() => {
                                                setSelectedIndex2(index)
                                            }}
                                        >
                                            <ListItemText primary={formatVerification(ele)}
                                                primaryTypographyProps={fontM}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Drawer>
                        <Box
                                    sx={{
                                        bgcolor: 'background.default',
                                         margin:'10px 10px 0px 240px !important' , width: '950px',  }} >
                           
                            {/* <Grid mt={2} mb={2} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center' }}>
                                <Typography sx={fontM} mr={1}>Creation Date - {createdOn && dayjs(createdOn).format('DD/MM/YYYY hh:mm:ss')}</Typography>
                                <Tooltip title={<Typography fontSize={12} sx={fontM}>{copyText}</Typography>}>
                                    <IconButton onClick={handleCopy}>
                                        <ContentCopyIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Typography sx={fontM} >JSON Response - </Typography>
                            <Grid mt={1} sx={{ wordBreak: 'break-word' }}>
                                <Typography sx={fontR} mt={2} >{data}</Typography>
                            </Grid> */}

                                    <Grid mt={2} mb={2} sx={{}}>

                                        {
                                            selectedIndex2 == 0 && <>

                                                <Grid container
                                                    justifyContent="center"
                                                    sx={{ paddingTop: '20px !important' }}>
                                                    {/* Srini - 12/11/24 */}
                                                    <Grid item lg={3} sx={{ height: 'auto !important' }}>
                                                        <Typography mb={2.5} sx={{ paddingRight: '20px !important', fontFamily: "cardiuma-M" }}>Full Name:</Typography>
                                                        <Typography mb={2.5} sx={fontM}>Mobile:</Typography>
                                                        <Typography mb={3} sx={fontM}>Email:</Typography>
                                                        <Typography mb={3} sx={fontM}>Stage:</Typography>
                                                        <Typography mb={3} sx={fontM}>Client Id:</Typography>
                                                        <Typography mb={3} sx={fontM}>Father's name:</Typography>
                                                    </Grid>
                                                    {/* Srini - 12/11/24 */}
                                                    <Grid item lg={9} >
                                                        <Typography sx={fontR} mb={2.5}>{perData?.name || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={2.5}> {perData?.mobile || "NULL"}</Typography>

                                                        <Grid sx={{ display: 'flex !important', flexDirection: 'row !important', alignItems: 'center !important' }}>
                                                            <Typography sx={fontR} mb={2}>{perData?.email || "NULL"}</Typography>
                                                            <Tooltip title={<Typography fontSize={12} sx={fontM}>{copyText}</Typography>}>
                                                                <IconButton sx={{ paddingTop: '0' }} onClick={handleCopyEmail}>
                                                                    <ContentCopyIcon sx={{ padding: '0', }} fontSize='small' />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Typography sx={fontR} mb={2.5}> {perData?.kyc_status || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={3}></Typography>
                                                        <Typography sx={fontR} mb={3}>{perData?.client_id || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={3}>{fatherName || "NULL"}</Typography>
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    container
                                                    justifyContent="flex-end"
                                                    sx={{ mt: 2, pr: '5%' }}
                                                >                                                                                              
                                                <Grid sx={{ display: "flex", gap: "20px" }}>

                                                    {(perData?.kyc_status == "completed" || perData?.kyc_status == "completed_bo_pending") && (
                                                        <Button
                                                            disabled={repushLoader}
                                                            onClick={handleKycCheck}
                                                            variant="contained"
                                                            sx={repushLoader ? disableKycCheckButton : selfieButton}
                                                        >
                                                            {repushLoader ? "Checking" : "Check KYC Status"}
                                                        </Button>
                                                    )}

                                                        <Button
                                                            disabled={repushLoader}
                                                            onClick={handleRepush}
                                                            variant="contained"
                                                            sx={repushLoader ? disabledrepushButton : repushButton}
                                                        >
                                                            {repushLoader ? "Pushing" : "Re Push"}
                                                        </Button>
                                                    </Grid>                                                                                          
                                                </Grid>
                                            </>
                                        }

                                {
                                    selectedIndex2 == 1 && <>
                                                <Grid container
                                                    justifyContent="center"
                                                    sx={{ paddingTop: '20px !important' }}>
                                                    {/* Srini - 12/11/24 */}
                                                    <Grid item lg={3} sx={{ height: 'auto !important' }}>
                                                        <Typography mb={2.5} sx={{ paddingRight: '20px !important', fontFamily: "cardiuma-M" }}>Full Name:</Typography>
                                                        <Typography mb={2.5} sx={fontM}>Mobile:</Typography>
                                                        <Typography mb={3} sx={fontM}>Email:</Typography>
                                                        <Typography mb={3} sx={fontM}>Stage:</Typography>
                                                        <Typography mb={3} sx={fontM}>Client Id:</Typography>
                                                        <Typography mb={3} sx={fontM}>Father's name:</Typography>
                                                    </Grid>
                                                    {/* Srini - 12/11/24 */}
                                                    <Grid item lg={9} >
                                                        <Typography sx={fontR} mb={2.5}>{perData?.name || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={2.5}> {perData?.mobile || "NULL"}</Typography>

                                                        <Grid sx={{ display: 'flex !important', flexDirection: 'row !important', alignItems: 'center !important' }}>
                                                            <Typography sx={fontR} mb={2}>{perData?.email || "NULL"}</Typography>
                                                            <Tooltip title={<Typography fontSize={12} sx={fontM}>{copyText}</Typography>}>
                                                                <IconButton sx={{ paddingTop: '0' }} onClick={handleCopyEmail}>
                                                                    <ContentCopyIcon sx={{ padding: '0', }} fontSize='small' />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Typography sx={fontR} mb={2.5}> {perData?.kyc_status || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={3}></Typography>
                                                        <Typography sx={fontR} mb={3}>{perData?.client_id || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={3}>{fatherName || "NULL"}</Typography>
                                                    </Grid>
                                                </Grid>
                                                {

                                                    resendError &&
                                                    <Typography sx={{
                                                        color: "red !important",
                                                        fontSize: "14px !important",
                                                        fontFamily: "cardiuma-M !important",
                                                        paddingTop: "5px"
                                                    }}>
                                                        {resendError}
                                                    </Typography>
                                                }
                                                 <Grid
                                                    container
                                                    justifyContent="flex-end"
                                                    sx={{ mt: 2, pr: '5%' }}
                                                >
                                                    <Button sx={selfieButton}
                                          onClick={handleResendSelfieLink}
                                        >
                                           Resend Selfie Link
                                       </Button>
                                    </Grid>
                                    </>
                                }

                               


                                {
                                    selectedIndex2 == 2 && <>

                                              
                                                <Grid container
                                                    justifyContent="center"
                                                    sx={{ paddingTop: '20px !important' }}>
                                                    {/* Srini - 12/11/24 */}
                                                    <Grid item lg={3} sx={{ height: 'auto !important' }}>
                                                        <Typography mb={2.5} sx={{ paddingRight: '20px !important', fontFamily: "cardiuma-M" }}>Full Name:</Typography>
                                                        <Typography mb={2.5} sx={fontM}>Mobile:</Typography>
                                                        <Typography mb={3} sx={fontM}>Email:</Typography>
                                                        <Typography mb={3} sx={fontM}>Stage:</Typography>
                                                        <Typography mb={3} sx={fontM}>Client Id:</Typography>
                                                        <Typography mb={3} sx={fontM}>Father's name:</Typography>
                                                    </Grid>
                                                    {/* Srini - 12/11/24 */}
                                                    <Grid item lg={9} >
                                                        <Typography sx={fontR} mb={2.5}>{perData?.name || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={2.5}> {perData?.mobile || "NULL"}</Typography>

                                                        <Grid sx={{ display: 'flex !important', flexDirection: 'row !important', alignItems: 'center !important' }}>
                                                            <Typography sx={fontR} mb={2}>{perData?.email || "NULL"}</Typography>
                                                            <Tooltip title={<Typography fontSize={12} sx={fontM}>{copyText}</Typography>}>
                                                                <IconButton sx={{ paddingTop: '0' }} onClick={handleCopyEmail}>
                                                                    <ContentCopyIcon sx={{ padding: '0', }} fontSize='small' />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Typography sx={fontR} mb={2.5}> {perData?.kyc_status || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={3}></Typography>
                                                        <Typography sx={fontR} mb={3}>{perData?.client_id || "NULL"}</Typography>
                                                        <Typography sx={fontR} mb={3}>{fatherName || "NULL"}</Typography>
                                                    </Grid>
                                                </Grid>
                                                {

                                                    resendSignError &&
                                                    <Typography sx={{
                                                        color: "red !important",
                                                        fontSize: "14px !important",
                                                        fontFamily: "cardiuma-M !important",
                                                        paddingTop: "5px"
                                                    }}>
                                                            {resendSignError}
                                                    </Typography>
                                                }
                                                <Grid
                                                    container
                                                    justifyContent="flex-end"
                                                    sx={{ mt: 2, pr: '5%' }}
                                                >
                                                    <Button sx={selfieButton}
                                                        onClick={handleResendSignLink}
                                                    >
                                                        Resend Signature Link
                                                    </Button>
                                                </Grid>
                                    </>
                                }

                                       
                                
                            </Grid>
                        </Box>
                    </Box>
                </>
            }

            </Box>
        </Modal>
        {/* ConfirmDialog */}
        <Dialog
            open={docloader}
            onClose={()=>{setDocloader(false)}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
            '& .MuiDialog-paper': {
                width: '400px',  
                height: '380px', 
            }
            }}>
            <Box sx={alertbox}>
                <img src={loaderstatus?.type === "load" ? loadergif : (loaderstatus?.type === "success" ? success : errorgif )} height={200}></img>
            </Box>
            <DialogTitle id="alert-dialog-title" sx={dialogTitle}>
                {loaderstatus?.title}
            </DialogTitle>
            <DialogContentText id="alert-dialog-description" sx={dialogContentText}>
                {loaderstatus?.content}
            </DialogContentText>
            <DialogActions sx={dialogAction}>
                <Button sx={loaderstatus?.type === 'load' ? disabledButton: downloadButton } onClick={()=>{approveDocs(loaderstatus.doctype)}} autoFocus> OK </Button>
            </DialogActions>
      </Dialog>
            {uploadmodal?.open && <UploadDocument imagesDoc={imagesDoc} uploadmodal={uploadmodal} setUploadmodal={setUploadmodal} closeModal={closeModal} email={email} phone={phone} aadhar={aadhar} docobj={docobj} CompletedVerification={CompletedVerification} setDocdata={setDocdata} setUser={setUser} perData={perData}  picDetails={picDetails}/>}
            {/* added by dev-kartik on 02-04-25 */}
            <Modal
                open={uploadModalState.open}
                onClose={handleCloseUploadModal1}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        ...uploadModalStyle,
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            width: "100%",
                            position: "relative",
                            paddingTop: "10px",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "30px",
                                fontWeight: "400",
                                fontFamily: "cardiuma-M",
                            }}
                        >
                            {renderModalContent()}
                        </Typography>
                        <Button
                            onClick={handleCloseUploadModal1}
                            sx={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                            }}
                        >
                            <CloseIcon style={{ color: "red" }} />
                        </Button>
                    </Box>
                    <Box sx={{ marginTop: "35px" }}>
                        <FileUploader
                            multiple={false}
                            maxSize={"1mb"}
                            hoverTitle="rAI"
                            label="Upload or drop a file right here"
                            handleChange={(file) => {
                                handlePicFile(file, uploadModalState.type);
                            }}
                            name="file"
                        >
                            <Box
                                sx={{
                                    width: "400px",
                                    height: "60px",
                                    border: "2px dashed #aaa",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                }}
                            >
                                <Typography>
                                    Drag and Drop here /{" "}
                                    <span style={{ color: "#42a0f7", cursor: "pointer" }}>
                                        Browse File
                                    </span>
                                </Typography>
                            </Box>
                        </FileUploader>
                    </Box>
                    <Typography
                        sx={{
                            marginTop: "10px",
                            fontSize: "14px",
                            fontFamily: "cardiuma-M ! important",
                            color: error ? "#F44748" : "#000000",
                        }}
                    >
                        {fileName || error}
                    </Typography>
                    <Button
                        sx={{
                            marginTop: "20px",
                            width: "100px",
                            backgroundColor: enable
                                ? "#F44748 !important"
                                : "#D3D3D3 !important",
                            color: "#fff !important",
                        }}
                        disabled={!enable}
                        onClick={() => {
                            handleUpload(uploadModalState.type);
                        }}
                    >
                        Upload
                    </Button>
                </Box>
            </Modal>

            <Modal
                open={aggregatorModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        ...aggregatorModalStyle,
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            width: "100%",
                            position: "relative",
                            paddingTop: "10px",
                            "@media (max-width: 1650px)": {
                                paddingTop: "10px",
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                color: "var(--b, #000000) ! important",
                                fontFamily: "cardiuma-M ! important",
                                fontSize: "25px ! important",
                                fontStyle: "normal",
                                fontWeight: "400 ! important",
                                lineHeight: "20px ! important",
                            }}
                        >
                            Upload Documents For F&O
                        </Typography>
                        <Button
                            onClick={handleCloseAggregatorModal}
                            sx={{
                                minWidth: "unset",
                                padding: "0",
                                position: "absolute",
                                right: 0,
                                top: 0,
                                paddingTop: "10px",
                                "@media (max-width: 1650px)": {
                                    paddingTop: "10px",
                                },
                            }}
                        >
                            <CloseIcon style={{ color: "red" }} />
                        </Button>
                    </Box>

                    <FormControl
                        size="small"
                        sx={{
                            marginTop: "40px !important",
                            width: "70% !important",
                        }}
                    >
                        <InputLabel
                            sx={inputColor}
                            id="demo-select-small-label"
                            shrink={true}
                        >
                            Document Type
                        </InputLabel>

                        <Select
                            sx={select}
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={documentType}
                            label="Document Type"
                            onChange={(e) => setDocumentType(e.target.value)}
                            displayEmpty
                            MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                },
                                PaperProps: {
                                    style: {
                                        maxHeight: 200,
                                        top: "0px",
                                    },
                                },
                            }}
                        >
                            <MenuItem sx={intSelText} value="Bank_Statement">
                                Latest Bank Statement of Last 6 Months
                            </MenuItem>
                            <MenuItem sx={intSelText} value="Salary_Slip">
                                Salary Slip (Last Month)
                            </MenuItem>
                            <MenuItem sx={intSelText} value="ITR">
                                IT Return (Last Year)
                            </MenuItem>
                            <MenuItem sx={intSelText} value="Net_Worth">
                                Net Worth Certificate
                            </MenuItem>
                            <MenuItem sx={intSelText} value="Demat_Statement">
                                Demat Account Holding Statement
                            </MenuItem>
                            <MenuItem sx={intSelText} value="Form_16">
                                Copy of last Form 16
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <Box
                        sx={{
                            marginTop: "32px",
                            marginBottom: "5px",
                        }}
                    >
                        <FileUploader
                            multiple={false}
                            maxSize={"1mb"}
                            hoverTitle="rAI"
                            label="Upload or drop a file right here"
                            handleChange={(file) => {
                                handlePdf(file);
                            }}
                            name="file"
                        >
                            <Box
                                sx={{
                                    width: "400px",
                                    height: "60px",
                                    border: "2px dashed #aaa",
                                    backgroundColor: "#ffffff !important",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",

                                    cursor: "pointer",
                                    textAlign: "center",
                                    overflow: "hidden",
                                }}
                            >
                                <Box
                                    sx={{
                                        height: "60px",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            lineHeight: "normal !important",
                                            padding: "0 !important",
                                            margin: "0 !important",
                                        }}
                                    >
                                        Drag and Drop here /{" "}
                                        <span
                                            sx={{
                                                color: "#42a0f7 !important",
                                                fontSize: " 14px !important",
                                                fontFamily: "cardiuma-M ! important",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Browse File
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        </FileUploader>
                    </Box>
                    {error ? (
                        <Typography
                            sx={{
                                color: "red !important",
                                fontSize: "14px !important",
                                fontFamily: "cardiuma-M !important",
                            }}
                        >
                            {error}
                        </Typography>
                    ) : fileName ? (
                        <Typography
                            sx={{
                                color: "#000000 !important",
                                fontSize: "14px !important",
                                fontFamily: "cardiuma-M !important",
                            }}
                        >
                            {fileName}
                        </Typography>
                    ) : null}

                    {show && (
                        <Grid
                            mb={2}
                            sx={{
                                width: "100%",
                                display: "flex !important",
                                marginTop: "30px !important",
                                justifyContent: "center",
                            }}
                        >
                            <TextField
                                sx={{ width: "80%" }}
                                size="small"
                                type="password"
                                label="Password"
                                variant="outlined"
                                onChange={(event) => {
                                    setPassword(event.target.value);
                                }}
                            />
                            <Button
                                onClick={handlePasswordSubmit}
                                sx={{
                                    marginLeft: "15px !important",
                                    width: "100px !important",
                                    height: "38px !important",
                                    color: "#fff !important",
                                    backgroundColor: "#F44748 !important",
                                    fontSize: "11px !important",
                                    fontStyle: "normal !important",
                                    fontFamily: "cardiuma-M !important",
                                    textTransform: "initial !important",
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>
                    )}
                    <Button
                        sx={{
                            marginTop: "15px !important",
                            width: "100px !important",
                            height: "38px !important",
                            color: enable ? "#fff !important" : "#B0B0B0 !important",
                            backgroundColor: enable
                                ? "#F44748 !important"
                                : "#D3D3D3 !important",
                            fontSize: "11px !important",
                            fontStyle: "normal !important",
                            fontFamily: "cardiuma-M !important",
                            textTransform: "initial !important",
                            "@media (max-width: 1650px)": {
                                marginTop: "10px !important",
                            },
                        }}
                        disabled={!enable}
                        onClick={() => {
                            handleUpload("AccountAggregator");
                        }}
                    >
                        Upload
                    </Button>
                </Box>
            </Modal>


            <Modal open={openResendModal} onClose={() => setOpenResendModal(false)}>
                <Box
                    sx={{
                        width: 420,
                        p: 3,
                        bgcolor: "white",
                        borderRadius: 2,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        boxShadow: 24,
                        outline: "none"  // removes border
                    }}
                >
                    {/* CLOSE ICON RIGHT SIDE */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "end",
                            mb: 1
                        }}
                    >

                        {/* <Typography sx={{ fontFamily:"cardiuma-regular",display:"flex",textAlign:"center"}}>
                            hellow
                        </Typography> */}
                        <IconButton
                            onClick={() => {
                                setOpenResendModal(false)
                                setResendUrl("")
                            }}
                            sx={{ color: "#555" }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* TEXT */}
                    <Typography sx={{ mb: 1, fontSize: "16px",fontFamily:"cardiuma-regular" }}>
                        {contentText}
                    </Typography>

                    {/* URL */}
                    <Typography
                        sx={{
                            color: "blue",
                            wordBreak: "break-all",
                            mb: 3,
                            fontFamily: "cardiuma-regular"
                        }}
                    >
                        {resendUrl}
                    </Typography>

                    {/* COPY BUTTON */}
                    <Button
                        variant="contained"
                        onClick={handleResendCopy}
                        sx={{
                            background: "#000",
                            "&:hover": { background: "#000" },
                            textTransform: "none",
                            px: 3
                        }}
                    >
                        Copy Text & URL
                    </Button>
                </Box>
            </Modal>


        </>
    )
}

export default EditActionModal
